import { jsxs as c, jsx as a, Fragment as _0 } from "react/jsx-runtime";
import { useState as T, useEffect as C, useRef as O, useCallback as w0, forwardRef as V0 } from "react";
const p0 = {
  "roche-add-to-calendar": "roche-add-to-calendar",
  "roche-add-to-calendar__headline": "roche-add-to-calendar__headline"
};
var o0 = /* @__PURE__ */ ((e) => (e.SELF = "_self", e.BLANK = "_blank", e))(o0 || {});
const t0 = (e) => e ? new Date(e).toISOString() : "", b0 = (e) => e.replace(/-|:|\.\d{3}/g, ""), dt = ({
  heading: e,
  eventTitle: t,
  description: i,
  startDate: n,
  endDate: o,
  icsLabel: s,
  googleCalendarLabel: l,
  outlookOnlineLabel: d
}) => {
  const g = t0(n), _ = t0(o), r = b0(t0(n)), h = b0(t0(o)), m = [
    {
      title: t,
      text: s,
      href: `data:text/calendar,${encodeURIComponent(
        `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${t}
DESCRIPTION:${i}
DTSTART:${r}
DTEND:${h}
END:VEVENT
END:VCALENDAR`
      )}`,
      icon: "file"
    },
    {
      text: l,
      href: `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=${r}%2F${h}&text=${encodeURIComponent(t)}&details=${encodeURIComponent(i)}`,
      icon: "google-cal"
    },
    {
      text: d,
      href: `https://outlook.live.com/calendar/0/deeplink/compose?rru=addevent&path=%2Fcalendar%2Faction%2Fcompose&startdt=${g}&enddt=${_}&subject=${t}&body=${i}`,
      icon: "outlook"
    }
  ];
  return /* @__PURE__ */ c("div", { className: p0["roche-add-to-calendar"], children: [
    /* @__PURE__ */ a("h3", { className: p0["roche-add-to-calendar__headline"], children: e }),
    m.map((N, u) => /* @__PURE__ */ a(
      "roche-button",
      {
        style: { margin: 0 },
        appearance: "secondary",
        alignment: "left",
        download: N.title,
        text: N.text,
        href: N.href,
        "left-icon": N.icon,
        target: o0.BLANK
      },
      u
    ))
  ] });
};
function H0(e) {
  var t, i, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (i = H0(e[t])) && (n && (n += " "), n += i);
  } else for (i in e) e[i] && (n && (n += " "), n += i);
  return n;
}
function b() {
  for (var e, t, i = 0, n = "", o = arguments.length; i < o; i++) (e = arguments[i]) && (t = H0(e)) && (n && (n += " "), n += t);
  return n;
}
const D = {
  "animated-words": "animated-words",
  "animated-words__headline": "animated-words__headline",
  "animated-words__text-container": "animated-words__text-container",
  "animated-words__words-container": "animated-words__words-container",
  "animated-words__word": "animated-words__word",
  "animated-words__word--active": "animated-words__word--active",
  "animated-words__word--previous": "animated-words__word--previous",
  "animated-words__word--next": "animated-words__word--next",
  "animated-words__word--red": "animated-words__word--red",
  "animated-words__word--orange": "animated-words__word--orange",
  "animated-words__word--purple": "animated-words__word--purple",
  "animated-words__word--brand": "animated-words__word--brand",
  "animated-words__word--effect": "animated-words__word--effect",
  "animated-words--animated": "animated-words--animated"
}, F0 = (e) => {
  const [t, i] = T(!1);
  return C(() => {
    const n = new IntersectionObserver(([o]) => i(o.isIntersecting));
    return e.current && n.observe(e.current), () => {
      n.disconnect();
    };
  }, [e]), t;
}, L0 = 1400, j0 = ["red", "orange", "purple", "brand"], ht = ({ headline: e, words: t }) => {
  const i = O(null), [n, o] = T(0), s = F0(i), l = t ? t.trim().split(`
`) : [], d = l.length <= 3 && l.length > 1 ? [...l, ...l] : l, g = l.length > 1, _ = (r) => {
    const h = r % l.length === l.length - 1 ? "animated-words__word--effect" : `animated-words__word--${j0[r % l.length % l.length]}`;
    if (!g)
      return b(D["animated-words__word"], D[h], {
        [D["animated-words__word--active"]]: !0
      });
    const m = d.length, N = r === n, u = r === (n - 1 + m) % m, p = r === (n + 1 + m) % m;
    return b(D["animated-words__word"], D[h], {
      [D["animated-words__word--active"]]: N,
      [D["animated-words__word--previous"]]: u,
      [D["animated-words__word--next"]]: p
    });
  };
  return C(() => {
    if (g && s) {
      const r = setInterval(() => {
        o((h) => (h + 1) % d.length);
      }, L0);
      return () => clearInterval(r);
    }
  }, [l, s]), /* @__PURE__ */ c(
    "h2",
    {
      ref: i,
      className: b(D["animated-words"], {
        [D["animated-words--animated"]]: g
      }),
      "aria-label": `${e} ${t.replaceAll(`
`, ", ")}`,
      children: [
        /* @__PURE__ */ a("span", { className: D["animated-words__headline"], children: e }),
        /* @__PURE__ */ a("div", { className: D["animated-words__text-container"], children: d.map((r, h) => /* @__PURE__ */ a("span", { className: _(h), children: r }, h)) })
      ]
    }
  );
}, P0 = "avatar", X0 = "avatar__fallback", Y0 = "avatar__icon", l0 = {
  avatar: P0,
  avatar__fallback: X0,
  avatar__icon: Y0
}, vt = ({ children: e }) => /* @__PURE__ */ a("div", { className: l0.avatar, children: e ?? /* @__PURE__ */ a("div", { className: l0.avatar__fallback, children: /* @__PURE__ */ a("div", { className: l0.avatar__icon, children: /* @__PURE__ */ a("roche-icon", { icon: "default-avatar", height: "100%" }) }) }) }), K0 = "overline", W0 = "overline__text", x0 = {
  overline: K0,
  overline__text: W0
}, Q0 = ({ overlineText: e, slot: t }) => /* @__PURE__ */ a("div", { className: x0.overline, slot: t, children: /* @__PURE__ */ a("p", { className: x0.overline__text, children: e }) }), f0 = {
  "roche-back-to-branch": "roche-back-to-branch",
  "roche-back-to-branch__content": "roche-back-to-branch__content"
}, mt = ({
  overlineText: e,
  headline: t,
  linkText: i,
  link: n,
  icon: o,
  slot: s
}) => /* @__PURE__ */ c("section", { className: f0["roche-back-to-branch"], slot: s, children: [
  /* @__PURE__ */ c("div", { className: f0["roche-back-to-branch__content"], children: [
    e && /* @__PURE__ */ a(Q0, { overlineText: e }),
    /* @__PURE__ */ a("roche-headline", { level: "5", headline: t })
  ] }),
  /* @__PURE__ */ a("roche-text-link", { "right-icon": o, href: n, text: i, target: o0.SELF })
] });
var n0 = /* @__PURE__ */ ((e) => (e.VARIANT_A = "contact-person--variant-a", e.VARIANT_A_WITHOUT_IMAGE = "contact-person--variant-a-without-image", e.VARIANT_B = "contact-person--variant-b", e))(n0 || {});
const K = {
  "contact-person": "contact-person",
  "contact-person__avatar": "contact-person__avatar",
  "contact-person__name": "contact-person__name",
  "contact-person__job-title": "contact-person__job-title",
  "contact-person__phone-number": "contact-person__phone-number",
  "contact-person__email-address": "contact-person__email-address"
}, wt = ({
  layout: e = n0.VARIANT_A,
  name: t,
  jobTitle: i,
  phoneNumber: n,
  emailAddress: o,
  children: s,
  slot: l
}) => {
  const d = e !== n0.VARIANT_B, g = e !== n0.VARIANT_A_WITHOUT_IMAGE && s;
  return /* @__PURE__ */ c("div", { className: K["contact-person"], slot: l, children: [
    g && /* @__PURE__ */ a("div", { className: K["contact-person__avatar"], children: s }),
    /* @__PURE__ */ a("h3", { className: K["contact-person__name"], children: t }),
    /* @__PURE__ */ a("p", { className: K["contact-person__job-title"], children: i }),
    d && n && /* @__PURE__ */ a("div", { className: K["contact-person__phone-number"], children: /* @__PURE__ */ a(
      "roche-text-link",
      {
        href: `tel:${n}`,
        text: n,
        "left-icon": "phone",
        type: "contact-person"
      },
      "phone-number"
    ) }),
    d && o && /* @__PURE__ */ a("div", { className: K["contact-person__email-address"], children: /* @__PURE__ */ a(
      "roche-text-link",
      {
        href: `mailto:${o}`,
        text: o,
        "left-icon": "email",
        type: "contact-person"
      },
      "email-address"
    ) })
  ] });
}, J0 = "footer", e2 = "footer__copyright", R = {
  footer: J0,
  "footer__first-row": "footer__first-row",
  "footer__second-row": "footer__second-row",
  "footer__third-row": "footer__third-row",
  "footer__quick-links": "footer__quick-links",
  "footer__helpful-links-title": "footer__helpful-links-title",
  "footer__stock-price": "footer__stock-price",
  "footer__quick-links-nav": "footer__quick-links-nav",
  "footer__social-links-nav": "footer__social-links-nav",
  footer__copyright: e2,
  "footer__social-links": "footer__social-links",
  "footer__service-links": "footer__service-links",
  "footer__legal-text": "footer__legal-text"
}, ut = ({
  quickLinksTitle: e,
  quickLinks: t,
  helpfulLinksTitle: i,
  helpfulLinks: n,
  stockPrice: o,
  socialLinksTitle: s,
  socialLinks: l,
  serviceLinksTitle: d,
  serviceLinks: g,
  year: _,
  date: r,
  copyright: h,
  text: m
}) => /* @__PURE__ */ a("footer", { className: R.footer, children: /* @__PURE__ */ c("roche-grid", { layout: "12", "no-padding": !0, children: [
  /* @__PURE__ */ c("roche-grid", { layout: "3-1-5-3", class: R["footer__first-row"], fullWidth: !0, children: [
    /* @__PURE__ */ a("nav", { className: R["footer__quick-links-nav"], "aria-label": e, slot: "left", children: /* @__PURE__ */ a("ul", { className: R["footer__quick-links"], children: t }) }),
    /* @__PURE__ */ c("nav", { "aria-labelledby": "helpful-links-title", slot: "center-right", children: [
      /* @__PURE__ */ a("h3", { className: R["footer__helpful-links-title"], id: "helpful-links-title", children: i }),
      /* @__PURE__ */ a("ul", { className: R["footer__helpful-links"], children: n })
    ] }),
    o ? /* @__PURE__ */ a("div", { className: R["footer__stock-price"], slot: "right", children: o }) : /* @__PURE__ */ a("div", { slot: "right" })
  ] }),
  /* @__PURE__ */ c("roche-grid", { layout: "4-8", class: R["footer__second-row"], fullWidth: !0, children: [
    /* @__PURE__ */ a("nav", { className: R["footer__social-links-nav"], "aria-label": s, slot: "left", children: /* @__PURE__ */ a("ul", { className: R["footer__social-links"], children: l }) }),
    /* @__PURE__ */ a("nav", { "aria-label": d, slot: "right", children: /* @__PURE__ */ a("ul", { className: R["footer__service-links"], children: g }) })
  ] }),
  /* @__PURE__ */ c("roche-grid", { layout: "4-8", class: R["footer__third-row"], fullWidth: !0, children: [
    /* @__PURE__ */ c("div", { className: R.footer__copyright, slot: "left", children: [
      "© ",
      /* @__PURE__ */ a("time", { children: _ }),
      "  ",
      h,
      "  ",
      /* @__PURE__ */ a("time", { children: r })
    ] }),
    /* @__PURE__ */ a("div", { className: R["footer__legal-text"], slot: "right", children: m })
  ] })
] }) }), y0 = () => {
  const [e, t] = T(0);
  return C(() => {
    const i = () => {
      t(window.scrollY);
    };
    return window.addEventListener("scroll", i), () => {
      window.removeEventListener("scroll", i);
    };
  }, []), e;
}, a2 = () => {
  const e = y0(), [t, i] = T(null), [n, o] = T(e);
  return C(() => {
    e > n ? i("down") : e < n && i("up"), o(e);
  }, [e, n]), t;
}, t2 = (e) => {
  C(() => {
    const { body: t } = document;
    return e ? (t.style.overflow = "hidden", t.style.position = "relative") : (t.style.overflow = "", t.style.position = ""), () => {
      t.style.overflow = "", t.style.position = "";
    };
  }, [e]);
}, I0 = (e) => {
  C(() => {
    const t = (i) => {
      i.key === "Escape" && e(null);
    };
    return window.addEventListener("keydown", t), () => {
      window.removeEventListener("keydown", t);
    };
  }, [e]);
}, C0 = (e, t, i) => {
  const n = w0(
    (o) => {
      t && e.current && !e.current.contains(o.target) && i();
    },
    [e, t, i]
  );
  C(() => (t ? (document.addEventListener("mousedown", n), document.addEventListener("focusin", n)) : (document.removeEventListener("mousedown", n), document.removeEventListener("focusin", n)), () => {
    document.removeEventListener("mousedown", n), document.removeEventListener("focusin", n);
  }), [t, n]);
}, A = {
  "mobile-navigation": "mobile-navigation",
  "mobile-navigation__overlay": "mobile-navigation__overlay",
  "mobile-navigation__overlay--open": "mobile-navigation__overlay--open",
  "mobile-navigation__overlay--closing": "mobile-navigation__overlay--closing",
  "mobile-navigation__header": "mobile-navigation__header",
  "mobile-navigation__worldwide-link": "mobile-navigation__worldwide-link",
  "mobile-navigation__header-link": "mobile-navigation__header-link",
  "mobile-navigation__close-button": "mobile-navigation__close-button",
  "mobile-navigation__list": "mobile-navigation__list",
  "mobile-navigation__list--primary": "mobile-navigation__list--primary",
  "mobile-navigation__chevron": "mobile-navigation__chevron",
  "mobile-navigation__list-item": "mobile-navigation__list-item",
  "mobile-navigation__list-item--open": "mobile-navigation__list-item--open",
  "mobile-navigation__list-item--active": "mobile-navigation__list-item--active",
  "mobile-navigation__list-item-button": "mobile-navigation__list-item-button",
  "mobile-navigation__list-item-link": "mobile-navigation__list-item-link",
  "mobile-navigation__submenu-list": "mobile-navigation__submenu-list",
  "mobile-navigation__submenu-item": "mobile-navigation__submenu-item",
  "mobile-navigation__submenu-item--active": "mobile-navigation__submenu-item--active",
  "mobile-navigation__submenu-item-title": "mobile-navigation__submenu-item-title",
  "mobile-navigation__submenu-item-title--active": "mobile-navigation__submenu-item-title--active",
  "mobile-navigation__submenu-item-arrow": "mobile-navigation__submenu-item-arrow",
  "mobile-navigation__submenu-item-link": "mobile-navigation__submenu-item-link",
  "mobile-navigation__meta-nav": "mobile-navigation__meta-nav"
}, X = (e) => e == null ? void 0 : e.replace(/^\/+|\/+$/g, ""), k = (e, t) => X(e) === X(t), r0 = (e, t, i) => {
  const n = X(i) === X(t);
  return b(A[`${e}`], n && A[`${e}--active`]);
}, n2 = (e, t) => e.findIndex(
  ({ url: i, nestedLinks: n }) => X(t) === X(i) || (n == null ? void 0 : n.some(
    (o) => X(o.url) === X(t)
  ))
), I = {
  "main-navigation": "main-navigation",
  "main-navigation__submenu": "main-navigation__submenu",
  "main-navigation__submenu-item--active": "main-navigation__submenu-item--active",
  "main-navigation__item": "main-navigation__item",
  "main-navigation__item--active": "main-navigation__item--active",
  "main-navigation__item--open": "main-navigation__item--open",
  "main-navigation__item--separator": "main-navigation__item--separator",
  "main-navigation__item-button": "main-navigation__item-button",
  "navigation-item__link": "navigation-item__link",
  "main-navigation__submenu-link": "main-navigation__submenu-link",
  "main-navigation__submenu-link--title": "main-navigation__submenu-link--title"
}, i2 = ({ nav: e, primaryNavLabel: t, currentPage: i }) => {
  const [n, o] = T(null), s = O(null);
  I0(o), C0(s, n !== null, () => o(null));
  const l = (r, h) => {
    o(r === n ? null : r), r === n ? s.current = null : s.current = h.current;
  }, d = (r, h) => {
    o(r), s.current = h.current;
  }, g = () => {
    o(null), s.current = null;
  }, _ = (r, h) => {
    const { nestedLinks: m, text: N, url: u } = r, p = O(null);
    if (!r.url)
      return /* @__PURE__ */ a(
        "li",
        {
          className: b(I["main-navigation__item"], I["main-navigation__item--separator"]),
          "aria-hidden": "true"
        },
        "separator" + h
      );
    const v = n === h, w = b(
      I["main-navigation__item"],
      k(u, i) && I["main-navigation__item--active"],
      v && I["main-navigation__item--open"]
    );
    return m != null && m.length ? /* @__PURE__ */ c("li", { className: w, ref: p, children: [
      /* @__PURE__ */ a(
        "button",
        {
          className: I["main-navigation__item-button"],
          "aria-controls": u,
          "aria-expanded": n === h,
          onMouseEnter: () => d(h, p),
          onMouseLeave: g,
          onClick: () => l(h, p),
          children: N
        }
      ),
      /* @__PURE__ */ c(
        "ul",
        {
          className: I["main-navigation__submenu"],
          id: u,
          onMouseEnter: () => d(h, p),
          onMouseLeave: g,
          children: [
            /* @__PURE__ */ a("li", { className: I["main-navigation__submenu-item"], children: /* @__PURE__ */ c(
              "a",
              {
                className: b(I["main-navigation__submenu-link"], I["main-navigation__submenu-link--title"]),
                href: u,
                onClick: r.onClick,
                "aria-current": k(u, i) ? "page" : !1,
                children: [
                  /* @__PURE__ */ a("span", { className: I["main-navigation__submenu-label"], children: N }),
                  /* @__PURE__ */ a("roche-icon", { icon: "arrow-right", height: "24px" })
                ]
              }
            ) }),
            m.map((f, E) => /* @__PURE__ */ a(
              "li",
              {
                className: b(
                  I["main-navigation__submenu-item"],
                  k(f == null ? void 0 : f.url, i) && I["main-navigation__submenu-item--active"]
                ),
                children: /* @__PURE__ */ a(
                  "a",
                  {
                    className: I["main-navigation__submenu-link"],
                    href: f == null ? void 0 : f.url,
                    onClick: f == null ? void 0 : f.onClick,
                    "aria-current": k(f == null ? void 0 : f.url, i) ? "page" : !1,
                    children: f.text
                  }
                )
              },
              "sub" + E
            ))
          ]
        }
      )
    ] }, h) : /* @__PURE__ */ a("li", { className: w, ref: p, children: /* @__PURE__ */ a(
      "a",
      {
        className: I["navigation-item__link"],
        href: u,
        "aria-current": k(u, i) ? "page" : !1,
        onClick: r.onClick,
        children: N
      }
    ) }, h);
  };
  return /* @__PURE__ */ a("nav", { "aria-label": t, children: /* @__PURE__ */ a("ul", { className: I["main-navigation"], children: e.map((r, h) => _(r, h)) }) });
}, B = {
  "meta-navigation": "meta-navigation",
  "meta-navigation__items": "meta-navigation__items",
  "meta-navigation__item-icon": "meta-navigation__item-icon",
  "meta-navigation__item": "meta-navigation__item",
  "meta-navigation__item--icon": "meta-navigation__item--icon",
  "meta-navigation__item--active": "meta-navigation__item--active",
  "meta-navigation__item-link": "meta-navigation__item-link",
  "meta-navigation__separator": "meta-navigation__separator"
};
var s0 = /* @__PURE__ */ ((e) => (e.DROPDOWN = "dropdown", e.INLINE_LIST = "inline-list", e))(s0 || {});
const G = {
  "language-switch-dropdown": "language-switch-dropdown",
  "language-switch-dropdown__chevron-icon": "language-switch-dropdown__chevron-icon",
  "language-switch-dropdown__open": "language-switch-dropdown__open",
  "language-switch-dropdown__list": "language-switch-dropdown__list",
  "language-switch-dropdown__button": "language-switch-dropdown__button",
  "language-switch-dropdown__list-item": "language-switch-dropdown__list-item",
  "language-switch-dropdown__link": "language-switch-dropdown__link",
  "language-switch-dropdown__link--selected": "language-switch-dropdown__link--selected"
}, W = {
  "language-switch-inline": "language-switch-inline",
  "language-switch-inline__list": "language-switch-inline__list",
  "language-switch-inline__list-item": "language-switch-inline__list-item",
  "language-switch-inline__link": "language-switch-inline__link",
  "language-switch-inline__link--selected": "language-switch-inline__link--selected"
}, E0 = ({
  alternates: e,
  currentLocale: t,
  currentPage: i,
  translatedLocale: n,
  layout: o,
  onClick: s
}) => {
  const [l, d] = T(!1), g = O(null), _ = O(null);
  I0(d), C0(g, l, () => d(!1));
  const r = (p) => {
    d((v) => {
      const w = !v;
      return g.current = w ? p.current : null, w;
    });
  }, h = (p) => {
    d(!0), g.current = p.current;
  }, m = () => {
    d(!1), g.current = null;
  }, N = (p) => /* @__PURE__ */ a("div", { className: W["language-switch-inline"], children: /* @__PURE__ */ a("ul", { className: W["language-switch-inline__list"], children: p.map((v, w) => {
    const f = v.url === i;
    return n[v.locale] && /* @__PURE__ */ a("li", { className: W["language-switch-inline__list-item"], children: f ? /* @__PURE__ */ a(
      "span",
      {
        className: b(
          W["language-switch-inline__link"],
          f && W["language-switch-inline__link--selected"]
        ),
        "aria-current": "page",
        "aria-disabled": !0,
        children: n[v.locale]
      }
    ) : /* @__PURE__ */ a(
      "a",
      {
        className: W["language-switch-inline__link"],
        href: v.url,
        "aria-disabled": !1,
        onClick: () => s(v.locale),
        children: n[v.locale]
      }
    ) }, w);
  }) }) }), u = (p, v) => /* @__PURE__ */ c(
    "div",
    {
      className: b(
        G["language-switch-dropdown"],
        l && G["language-switch-dropdown__open"]
      ),
      children: [
        /* @__PURE__ */ c(
          "button",
          {
            className: G["language-switch-dropdown__button"],
            id: "language-switch-button",
            "aria-expanded": l,
            "aria-controls": "language-switch-list",
            onClick: () => r(_),
            onMouseEnter: () => h(_),
            onMouseLeave: m,
            children: [
              v.toUpperCase(),
              /* @__PURE__ */ a(
                "roche-icon",
                {
                  class: G["language-switch-dropdown__chevron-icon"],
                  icon: "chevron-down",
                  width: "18px"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ a(
          "ul",
          {
            ref: _,
            className: G["language-switch-dropdown__list"],
            id: "language-switch-list",
            "aria-hidden": !l,
            onMouseEnter: () => h(_),
            onMouseLeave: m,
            inert: l ? null : "",
            children: p.map((w, f) => {
              const E = w.url === i;
              return n[w.locale] && /* @__PURE__ */ a("li", { className: G["language-switch-dropdown__list-item"], children: E ? /* @__PURE__ */ a(
                "span",
                {
                  className: b(
                    G["language-switch-dropdown__link"],
                    E && G["language-switch-dropdown__link--selected"]
                  ),
                  "aria-current": "page",
                  "aria-disabled": !0,
                  children: n[w.locale]
                }
              ) : /* @__PURE__ */ a(
                "a",
                {
                  href: w.url,
                  onClick: () => s(w.locale),
                  className: G["language-switch-dropdown__link"],
                  "aria-disabled": !1,
                  children: n[w.locale]
                }
              ) }, f);
            })
          }
        )
      ]
    }
  );
  return o === s0.DROPDOWN ? u(e, t) : N(e);
}, o2 = ({
  nav: e,
  secondaryNavLabel: t,
  searchLink: i,
  worldWideLink: n,
  currentPage: o,
  languageSwitchConfig: s
}) => {
  const l = ((s == null ? void 0 : s.alternates) ?? []).length > 0, d = !!(l || n || i);
  return /* @__PURE__ */ c("nav", { className: B["meta-navigation"], "aria-label": t, children: [
    /* @__PURE__ */ a("ul", { className: B["meta-navigation__items"], children: e.map((g, _) => /* @__PURE__ */ a(
      "li",
      {
        className: b(
          B["meta-navigation__item"],
          k(g.url, o) && B["meta-navigation__item--active"]
        ),
        children: /* @__PURE__ */ a(
          "a",
          {
            className: B["meta-navigation__item-link"],
            href: g.url,
            onClick: g.onClick,
            "aria-current": k(g.url, o) ? "page" : !1,
            children: g.text ?? ""
          }
        )
      },
      _
    )) }),
    d && /* @__PURE__ */ a("div", { className: B["meta-navigation__separator"] }),
    l && s && /* @__PURE__ */ a(
      E0,
      {
        currentLocale: s.currentLocale,
        currentPage: o,
        alternates: s.alternates,
        translatedLocale: s.translations.translatedLocale,
        layout: s0.DROPDOWN,
        onClick: s.handleClickTracking
      }
    ),
    (n == null ? void 0 : n.url) && /* @__PURE__ */ a(
      "a",
      {
        className: b(
          B["meta-navigation__item"],
          B["meta-navigation__item--icon"],
          k(n == null ? void 0 : n.url, o) && B["meta-navigation__item--active"]
        ),
        href: n.url,
        onClick: n == null ? void 0 : n.onClick,
        "aria-label": n == null ? void 0 : n.label,
        "aria-current": k(n.url, o) ? "page" : !1,
        children: /* @__PURE__ */ a("roche-icon", { class: B["meta-navigation__item-icon"], icon: "globe", height: "20px" })
      }
    ),
    (i == null ? void 0 : i.url) && /* @__PURE__ */ a(
      "a",
      {
        className: b(
          B["meta-navigation__item"],
          B["meta-navigation__item--icon"],
          k(i == null ? void 0 : i.url, o) && B["meta-navigation__item--active"]
        ),
        href: i.url,
        onClick: i == null ? void 0 : i.onClick,
        "aria-label": i == null ? void 0 : i.label,
        "aria-current": k(i.url, o) ? "page" : !1,
        children: /* @__PURE__ */ a("roche-icon", { class: B["meta-navigation__item-icon"], icon: "search", height: "20px" })
      }
    )
  ] });
}, N0 = ({
  link: e,
  index: t,
  openItem: i,
  isNavOpen: n,
  currentPage: o,
  exploreLabel: s,
  handleToggleMenu: l
}) => {
  const { nestedLinks: d, text: g, url: _ } = e, r = i === t, h = O(null), m = O(null), [N, u] = T(0);
  if (C(() => {
    h.current && m.current && u(r ? h.current.scrollHeight : 0);
  }, [r, n, s]), !e.url)
    return null;
  if (!(d != null && d.length))
    return /* @__PURE__ */ a("li", { className: r0("mobile-navigation__list-item", _, o), children: /* @__PURE__ */ a("a", { className: A["mobile-navigation__list-item-link"], href: _, onClick: e.onClick, children: g }) }, t);
  const p = b(
    A["mobile-navigation__list-item"],
    r && A["mobile-navigation__list-item--open"]
  );
  return /* @__PURE__ */ c("li", { className: p, children: [
    /* @__PURE__ */ c(
      "button",
      {
        className: A["mobile-navigation__list-item-button"],
        onClick: () => l(t),
        "aria-controls": _,
        "aria-expanded": r,
        children: [
          g,
          /* @__PURE__ */ a("roche-icon", { class: A["mobile-navigation__chevron"], icon: "chevron-down", height: "24px" })
        ]
      }
    ),
    /* @__PURE__ */ c(
      "ul",
      {
        ref: h,
        className: A["mobile-navigation__submenu-list"],
        "aria-hidden": !r,
        style: {
          maxHeight: r ? `${N}px` : "0px",
          opacity: r ? 1 : 0
        },
        children: [
          /* @__PURE__ */ a("li", { className: r0("mobile-navigation__submenu-item-title", _, o), children: /* @__PURE__ */ c(
            "a",
            {
              className: A["mobile-navigation__submenu-item-link"],
              href: _,
              ref: m,
              onClick: e.onClick,
              "aria-label": g,
              "aria-current": k(_, o) ? "page" : !1,
              children: [
                s,
                /* @__PURE__ */ a(
                  "roche-icon",
                  {
                    class: A["mobile-navigation__submenu-item-arrow"],
                    icon: "arrow-right",
                    height: "24px"
                  }
                )
              ]
            }
          ) }, "title" + t),
          d.map((v, w) => /* @__PURE__ */ a(
            "li",
            {
              className: r0("mobile-navigation__submenu-item", v.url, o),
              children: /* @__PURE__ */ a(
                "a",
                {
                  className: A["mobile-navigation__submenu-item-link"],
                  href: v == null ? void 0 : v.url,
                  onClick: v == null ? void 0 : v.onClick,
                  "aria-current": k(v == null ? void 0 : v.url, o) ? "page" : !1,
                  children: v.text
                }
              )
            },
            "sub" + w
          ))
        ]
      }
    )
  ] }, t);
}, s2 = ({
  primaryNav: e,
  secondaryNav: t,
  worldWideLink: i,
  exploreLabel: n,
  closeNavLabel: o,
  currentPage: s,
  isNavOpen: l,
  setIsNavOpen: d,
  languageSwitchConfig: g
}) => {
  var L;
  const _ = O(null), r = O(null), [h, m] = T(!1), [N, u] = T(null);
  C(() => {
    const M = n2(e, s);
    u(M);
  }, [s, e]), C(() => {
    var M, V, S;
    l ? ((M = r.current) == null || M.showModal(), (V = _.current) == null || V.focus()) : (S = r.current) != null && S.open && m(!0);
  }, [l]);
  const p = () => {
    d(!1);
  }, v = (M) => {
    var V;
    M.target === r.current && h && M.propertyName === "transform" && (m(!1), (V = r.current) == null || V.close());
  }, w = (M) => {
    u((V) => V === M ? null : M);
  }, f = b(
    A["mobile-navigation__overlay"],
    l && A["mobile-navigation__overlay--open"],
    h && A["mobile-navigation__overlay--closing"]
  ), E = ((L = (g == null ? void 0 : g.alternates) ?? []) == null ? void 0 : L.length) > 0;
  return /* @__PURE__ */ a("nav", { className: A["mobile-navigation"], children: /* @__PURE__ */ c(
    "dialog",
    {
      className: f,
      onClose: () => d(!1),
      id: "mobile-navigation",
      ref: r,
      inert: l ? null : "",
      "aria-hidden": !l,
      onTransitionEnd: v,
      children: [
        /* @__PURE__ */ c("header", { className: A["mobile-navigation__header"], children: [
          /* @__PURE__ */ c(
            "a",
            {
              className: A["mobile-navigation__worldwide-link"],
              href: i == null ? void 0 : i.url,
              onClick: i == null ? void 0 : i.onClick,
              children: [
                /* @__PURE__ */ a("roche-icon", { class: A["mobile-navigation__globe-icon"], icon: "globe", height: "24px" }),
                i == null ? void 0 : i.label
              ]
            }
          ),
          /* @__PURE__ */ a(
            "button",
            {
              className: A["mobile-navigation__close-button"],
              onClick: p,
              ref: _,
              "aria-label": o,
              "aria-controls": "mobile-navigation",
              children: /* @__PURE__ */ a("roche-icon", { icon: "mobile-close", height: "32px" })
            }
          )
        ] }),
        /* @__PURE__ */ a("ul", { className: b(A["mobile-navigation__list"], A["mobile-navigation__list--primary"]), children: e.map((M, V) => /* @__PURE__ */ a(
          N0,
          {
            link: M,
            index: V,
            openItem: N,
            isNavOpen: l,
            exploreLabel: n,
            currentPage: s,
            handleToggleMenu: w
          },
          V
        )) }),
        /* @__PURE__ */ a("ul", { className: A["mobile-navigation__list"], children: t.map((M, V) => /* @__PURE__ */ a(
          N0,
          {
            link: M,
            index: V,
            openItem: N,
            isNavOpen: l,
            exploreLabel: n,
            currentPage: s,
            handleToggleMenu: w
          },
          V
        )) }),
        g && E && /* @__PURE__ */ a("div", { className: A["mobile-navigation__meta-nav"], children: /* @__PURE__ */ a(
          E0,
          {
            alternates: g.alternates,
            currentLocale: g.currentLocale,
            currentPage: s,
            translatedLocale: g.translations.translatedLocale,
            layout: s0.INLINE_LIST,
            onClick: g.handleClickTracking
          }
        ) })
      ]
    }
  ) });
}, l2 = "header", r2 = "header__logo", c2 = "header__actions", _2 = "header__search", g2 = "header__burger", H = {
  header: l2,
  "header__skip-link": "header__skip-link",
  "header__first-row": "header__first-row",
  "header__second-row": "header__second-row",
  header__logo: r2,
  "header__logo-mobile": "header__logo-mobile",
  "header__logo-link": "header__logo-link",
  header__actions: c2,
  header__search: _2,
  "header__search--active": "header__search--active",
  header__burger: g2,
  "header__mobile-nav": "header__mobile-nav",
  "header__secondary-nav": "header__secondary-nav",
  "header--scrolled": "header--scrolled",
  "header--transparent": "header--transparent",
  "header--hidden": "header--hidden"
}, d2 = 100, pt = ({
  homeLink: e,
  searchLink: t,
  worldWideLink: i,
  exploreLabel: n,
  openNavLabel: o,
  closeNavLabel: s,
  currentPage: l,
  isFixed: d,
  primaryNav: g,
  secondaryNav: _,
  primaryNavLabel: r,
  secondaryNavLabel: h,
  skipToContentLabel: m,
  languageSwitchConfig: N
}) => {
  const [u, p] = T(!1);
  t2(u);
  const v = () => {
    p(!u);
  }, w = y0(), f = a2(), E = w > 0, L = w < d2, M = !d && !L && f === "down", V = !E, S = b(
    H.header,
    d && H["header--fixed"],
    E && H["header--scrolled"],
    V && H["header--transparent"],
    M && H["header--hidden"]
  ), Y = l === (t == null ? void 0 : t.url);
  return /* @__PURE__ */ c("header", { className: S, children: [
    /* @__PURE__ */ a("a", { className: H["header__skip-link"], href: "#main-content", children: m }),
    /* @__PURE__ */ c("div", { className: H["header__first-row"], children: [
      /* @__PURE__ */ c(
        "a",
        {
          className: H["header__logo-link"],
          href: (e == null ? void 0 : e.url) ?? "/",
          "aria-label": e == null ? void 0 : e.label,
          onClick: e == null ? void 0 : e.onClick,
          children: [
            /* @__PURE__ */ a("roche-icon", { class: H.header__logo, icon: "logo", height: "40px" }),
            /* @__PURE__ */ a("roche-icon", { class: H["header__logo-mobile"], icon: "logo", height: "30px" })
          ]
        }
      ),
      /* @__PURE__ */ a("div", { className: H["header__secondary-nav"], children: /* @__PURE__ */ a(
        o2,
        {
          nav: _,
          secondaryNavLabel: h,
          worldWideLink: i,
          searchLink: t,
          currentPage: l,
          languageSwitchConfig: N
        }
      ) }),
      /* @__PURE__ */ c("div", { className: H.header__actions, children: [
        /* @__PURE__ */ a(
          "a",
          {
            href: t == null ? void 0 : t.url,
            className: b(H.header__search, Y && H["header__search--active"]),
            "aria-label": t == null ? void 0 : t.label,
            "aria-current": Y ? "page" : !1,
            onClick: t == null ? void 0 : t.onClick,
            children: /* @__PURE__ */ a("roche-icon", { className: H["header__search-icon"], icon: "search-mobile", height: "32px" })
          }
        ),
        /* @__PURE__ */ a(
          "button",
          {
            className: H.header__burger,
            onClick: v,
            "aria-label": o,
            "aria-controls": "mobile-navigation",
            "aria-expanded": u,
            children: /* @__PURE__ */ a("roche-icon", { class: H["header__burger-icon"], icon: "mobile-menu", height: "32px" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ a("div", { className: H["header__second-row"], children: /* @__PURE__ */ a(i2, { nav: g, primaryNavLabel: r, currentPage: l }) }),
    /* @__PURE__ */ a("div", { className: H["header__mobile-nav"], children: /* @__PURE__ */ a(
      s2,
      {
        primaryNav: g,
        secondaryNav: _,
        worldWideLink: i,
        exploreLabel: n,
        closeNavLabel: s,
        currentPage: l,
        isNavOpen: u,
        setIsNavOpen: p,
        languageSwitchConfig: N
      }
    ) })
  ] });
}, U = {
  "hero-teaser": "hero-teaser",
  "hero-teaser__info-container": "hero-teaser__info-container",
  "hero-teaser__text-container": "hero-teaser__text-container",
  "hero-teaser__title-container": "hero-teaser__title-container",
  "hero-teaser__title": "hero-teaser__title",
  "hero-teaser__overline": "hero-teaser__overline",
  "hero-teaser__button-container": "hero-teaser__button-container",
  "hero-teaser__image-container": "hero-teaser__image-container",
  "hero-teaser--unpublished": "hero-teaser--unpublished"
}, h2 = (e) => {
  const [t, i] = T(!1);
  return C(() => {
    const n = () => {
      i(window.innerWidth < e);
    };
    return n(), window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, [e]), t;
}, v2 = 16, R0 = (e) => e / v2;
var B0 = /* @__PURE__ */ ((e) => (e[e.SMALL = 320] = "SMALL", e[e.MEDIUM = 768] = "MEDIUM", e[e.LARGE = 1024] = "LARGE", e[e.X_LARGE = 1440] = "X_LARGE", e[e.XX_LARGE = 1920] = "XX_LARGE", e))(B0 || {});
const bt = ({
  teaserTitle: e,
  teaserOverline: t,
  teaserDescription: i,
  teaserImage: n,
  teaserImageRatio: o,
  imageOnLeftSide: s = !1,
  primaryButtonUrl: l,
  primaryButtonText: d,
  secondaryButton: g,
  onPrimaryButtonClick: _,
  leftIcon: r,
  rightIcon: h,
  unpublished: m
}) => {
  const u = h2(B0.MEDIUM) ? !0 : s, p = () => !Number(n) ? { src: n } : { "brightcove-id": n }, v = n && /* @__PURE__ */ a("div", { className: U["hero-teaser__image-container"], children: /* @__PURE__ */ a("roche-image", { style: { margin: 0 }, class: "teaser-image", ratio: o, alt: "", ...p() }) }), w = /* @__PURE__ */ c("div", { className: U["hero-teaser__info-container"], children: [
    /* @__PURE__ */ c("div", { className: U["hero-teaser__text-container"], children: [
      /* @__PURE__ */ c("div", { className: U["hero-teaser__title-container"], children: [
        t && t.length > 0 && /* @__PURE__ */ a("div", { className: U["hero-teaser__overline"], children: t }),
        e && /* @__PURE__ */ a("h2", { className: U["hero-teaser__title"], children: e })
      ] }),
      i && /* @__PURE__ */ a("p", { children: i })
    ] }),
    /* @__PURE__ */ c("div", { className: U["hero-teaser__button-container"], children: [
      d && /* @__PURE__ */ a(
        "roche-button",
        {
          style: { margin: 0 },
          href: l,
          appearance: "secondary",
          text: d,
          onClick: _,
          "left-icon": r,
          "right-icon": h
        }
      ),
      g
    ] })
  ] });
  return /* @__PURE__ */ a("section", { className: b(U["hero-teaser"], m && U["hero-teaser--unpublished"]), children: u ? /* @__PURE__ */ c(_0, { children: [
    v,
    " ",
    w
  ] }) : /* @__PURE__ */ c(_0, { children: [
    w,
    " ",
    v
  ] }) });
}, A0 = {
  "highlight-box": "highlight-box",
  "highlight-box--transparent": "highlight-box--transparent",
  "highlight-box--theme-aware": "highlight-box--theme-aware",
  "highlight-box--neutral": "highlight-box--neutral",
  "highlight-box--neutral-100": "highlight-box--neutral-100",
  "highlight-box--neutral-200": "highlight-box--neutral-200",
  "highlight-box--grey": "highlight-box--grey",
  "highlight-box--grey-50": "highlight-box--grey-50",
  "highlight-box--grey-100": "highlight-box--grey-100",
  "highlight-box--grey-200": "highlight-box--grey-200",
  "highlight-box--grey-300": "highlight-box--grey-300",
  "highlight-box--white": "highlight-box--white"
}, xt = ({ color: e, children: t }) => /* @__PURE__ */ a("section", { className: `${A0["highlight-box"]} ${A0[`highlight-box--${e}`]}`, children: t }), m2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill-rule='evenodd'%20d='M12%202.586%2021.414%2012%2012%2021.414%202.586%2012%2012%202.586ZM5.414%2012%2012%2018.586%2018.586%2012%2012%205.414%205.414%2012Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", w2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M10.8%202.8v14.6L5.5%2012l-1.4%201.4%207.7%207.7%207.7-7.7-1.4-1.4-5.3%205.3V2.8h-2z'/%3e%3c/svg%3e", u2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M21%2011H6.4l5.3-5.3-1.4-1.4L2.6%2012l7.7%207.7%201.4-1.4L6.4%2013H21v-2z'/%3e%3c/svg%3e", p2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M22%208L12%2018%202%208'/%3e%3c/svg%3e", b2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M16%2022L6%2012%2016%202'/%3e%3c/svg%3e", x2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M16.6%2012L7.3%202.7l1.4-1.4%2010%2010%20.7.7-.7.7-10%2010-1.4-1.4%209.3-9.3z'%20clip-rule='evenodd'/%3e%3c/svg%3e", f2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M2%2016L12%206l10%2010'/%3e%3c/svg%3e", N2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M2.6%2013h14.6l-5.3%205.3%201.4%201.4L21%2012l-7.7-7.7-1.4%201.4%205.3%205.3H2.6v2z'/%3e%3c/svg%3e", A2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M12.8%2021.2V6.6L18%2012l1.4-1.4-7.7-7.7L4%2010.5l1.4%201.4%205.3-5.3v14.6h2z'/%3e%3c/svg%3e", M2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill-rule='evenodd'%20d='M2%202a1%201%200%2000-1%201v15c0%20.6.4%201%201%201h7a2%202%200%20012%202%201%201%200%20102%200%202%202%200%20012-2h7c.6%200%201-.4%201-1V3c0-.6-.4-1-1-1h-6a5%205%200%2000-4%202%205%205%200%2000-4-2H2zm11%2015.5a4%204%200%20012-.5h6V4h-5a3%203%200%2000-3%203v10.5zm-2%200V7a3%203%200%2000-3-3H3v13h6a4%204%200%20012%20.5z'%20clip-rule='evenodd'/%3e%3c/svg%3e", z2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M20%203h-1V1h-2v2H7V1H5v2H4a2%202%200%2000-2%202v16c0%201.1.9%202%202%202h16a2%202%200%20002-2V5a2%202%200%2000-2-2zm0%2018H4V10h16v11zm0-13H4V5h16v3z'/%3e%3c/svg%3e", V2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M20.5%206.4l-11%2011L8.1%2016l-4.6-4.6L4.9%2010l4.6%204.6L19.1%205l1.4%201.4z'%20clip-rule='evenodd'/%3e%3c/svg%3e", H2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M12%2015.7l6-6-1.4-1.4-4.6%204.6-4.6-4.6L6%209.7l6%206z'/%3e%3c/svg%3e", y2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M8.3%2012l6%206%201.4-1.4-4.6-4.6%204.6-4.6L14.3%206l-6%206z'/%3e%3c/svg%3e", I2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M15.7%2012l-6-6-1.4%201.4%204.6%204.6-4.6%204.6L9.7%2018l6-6z'/%3e%3c/svg%3e", C2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M12%208.3l-6%206%201.4%201.4%204.6-4.6%204.6%204.6%201.4-1.4-6-6z'/%3e%3c/svg%3e", E2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M12%202a10%2010%200%20100%2020%2010%2010%200%20000-20z'/%3e%3c/svg%3e", R2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M17.6%205L12%2010.6%206.4%205%205%206.4l5.6%205.6L5%2017.6%206.4%2019l5.6-5.6%205.6%205.6%201.4-1.4-5.6-5.6L19%206.4%2017.6%205z'/%3e%3c/svg%3e", B2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2020%2020'%3e%3cpath%20d='M0%200h20v20H0z'/%3e%3c/svg%3e", T2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M4%204v10h10'/%3e%3c/svg%3e", k2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='m18.58%202.6%202.83%202.84a2%202%200%200%201%200%202.83l-7.44%207.44a2%202%200%200%201-2.83%200l-1.42-1.42%201.4-1.42%201.43%201.42%207.44-7.44-2.82-2.83-2.9%202.9-1.42-1.42%202.9-2.9a2%202%200%200%201%202.83%200ZM5.39%2021.46l-2.83-2.82a2%202%200%200%201%200-2.83l7.48-7.48a2%202%200%200%201%202.83%200l1.42%201.42-1.41%201.41-1.42-1.42-7.48%207.48%202.82%202.83%202.9-2.9%201.42%201.41-2.9%202.9a2%202%200%200%201-2.83%200Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", D2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M20%205.4L18.6%204%2012%2010.6%205.4%204%204%205.4l6.6%206.6L4%2018.6%205.4%2020l6.6-6.6%206.6%206.6%201.4-1.4-6.6-6.6L20%205.4z'%20clip-rule='evenodd'/%3e%3c/svg%3e", $2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2080%2080'%3e%3cpath%20d='m39.54%2021.61.46-.01a9.1%209.1%200%200%201%209.12%208.57l.01.46v.34a9.09%209.09%200%200%201-8.67%209.02L40%2040a9.1%209.1%200%200%201-9.14-9.03v-.34a9.09%209.09%200%200%201%208.68-9.02Zm.98-4.61H40a13.72%2013.72%200%200%200-13.8%2013.63v.34A13.7%2013.7%200%200%200%2039.48%2044.6H40a13.72%2013.72%200%200%200%2013.8-13.13v-.85A13.7%2013.7%200%200%200%2040.52%2017Zm17.33%2045.5H63l-4.36-8.21a9.27%209.27%200%200%200-8.23-4.79H29.6a9.27%209.27%200%200%200-8.23%204.79L17%2062.5h5.15l3.33-6.27a4.63%204.63%200%200%201%204.11-2.4h20.82a4.6%204.6%200%200%201%204.1%202.4l3.34%206.27Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", O2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M19.4%207.5h3.1V6h-3.1A2.3%202.3%200%200015%206H9.8V3.7h-6V6H1.5v1.5h2.3v2.3h6V7.5H15a2.3%202.3%200%20001.4%201.4v5.5a3%203%200%2000-2.1%202.1H1.5V18h12.9a3%203%200%20005.7%200h2.4v-1.5h-2.4a3%203%200%2000-2.1-2.1V8.9a2.3%202.3%200%20001.4-1.4zm-11.1.8h-3v-3h3v3zm10.4%209a1.5%201.5%200%2011-3%200%201.5%201.5%200%20013%200z'/%3e%3c/svg%3e", q2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M19%209h-4V3H9v6H5l7%207%207-7zm-8%202V5h2v6h1.2L12%2013.2%209.8%2011H11zm-6%207h14v2H5v-2z'/%3e%3c/svg%3e", Z2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M7.2%209.5h9.6L12%2014.3%207.2%209.5zm-.4-.4s0%200%200%200h0z'/%3e%3c/svg%3e", S2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill-rule='evenodd'%20d='M12%2022a10%2010%200%20100-20%2010%2010%200%20000%2020zm0-2a8%208%200%20100-16%208%208%200%20000%2016z'%20clip-rule='evenodd'/%3e%3c/svg%3e", G2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M22%206a2%202%200%2000-2-2H4a2%202%200%2000-2%202v12c0%201.1.9%202%202%202h16a2%202%200%20002-2V6zm-2%200l-8%205-8-5h16zm0%2012H4V8l8%205%208-5v10z'/%3e%3c/svg%3e", U2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M10%206v2H5v11h11v-5h2v6a1%201%200%2001-1%201H4a1%201%200%2001-1-1V7a1%201%200%20011-1h6zm11-3v8h-2V6.4l-7.8%207.8-1.4-1.4L17.6%205H13V3h8z'/%3e%3c/svg%3e", F2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M10.02%2020L10%2013H7v-3h3V8c0-2.7%201.67-4%204.08-4%201.15%200%202.14.09%202.43.12v2.83h-1.67c-1.3%200-1.56.62-1.56%201.53V10H17l-1%203h-2.72v7h-3.26z'/%3e%3c/svg%3e", L2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M22.6%2011l-3-2.7V4.2L16.2.7H6.9v6H3.5A1.1%201.1%200%20002.4%208V22a1.1%201.1%200%20001.1%201.1H23V11.8a1.1%201.1%200%2000-.4-.8zM7%2021.8h-3V8.2h3v13.6zM15%202.1h.5L18%204.8v.5h-3v-3zm-6.7%200h5.2v4.5h4.5v3.4H8.4V2.3zm13.1%2019.6H8.4V11.6h11.2v-1.3l2%201.7v9.8z'/%3e%3cpath%20d='M10.9%2016.1h1.5v1.5h-1.5v-1.5zM13.9%2016.1h1.5v1.5h-1.5v-1.5zM10.9%2019.1h1.5v1.5h-1.5v-1.5zM13.9%2019.1h1.5v1.5h-1.5v-1.5zM16.9%2016.1h1.5v1.5h-1.5v-1.5zM16.9%2019.1h1.5v1.5h-1.5v-1.5zM10.9%2013.1h7.5v1.5h-7.5v-1.5z'/%3e%3c/svg%3e", j2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M4%201H3v22h18V6.6l-.3-.3-5-5-.3-.3H4zm1%2020V3h9v5h5v13H5zM17.6%206L16%204.4V6h1.6zM11%208v6.7l-2.3-2.1L7.3%2014l4%203.7.7.7.7-.7%204-3.7-1.4-1.4-2.3%202.1V8h-2z'%20clip-rule='evenodd'/%3e%3c/svg%3e", P2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill-rule='evenodd'%20d='M4%201H3v22h18V6.6l-.3-.3-5-5-.3-.3H4Zm1%2020V3h9v5h5v13H5ZM17.6%206%2016%204.4V6h1.6Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", X2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill-rule='evenodd'%20d='M14.126%209H3V7h11.126A4.002%204.002%200%200%201%2022%208a4%204%200%200%201-7.874%201ZM16%208a2%202%200%201%201%204%200%202%202%200%200%201-4%200Zm-6.126%207H21v2H9.874A4.002%204.002%200%200%201%202%2016a4%204%200%200%201%207.874-1ZM8%2016a2%202%200%201%201-4%200%202%202%200%200%201%204%200Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", Y2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M12%202a10%2010%200%20100%2020%2010%2010%200%20000-20zm8%209h-2.8c-.2-2.2-.8-4.3-1.8-6.2a8%208%200%20014.5%206.2zm-7.5-7a13%2013%200%20012.7%207H9c.2-2.6%201-5%202.5-7h1zm-3.8.7c-1%202-1.6%204-1.7%206.3H4a8%208%200%20014.7-6.3zM4%2013h3c0%202.4.6%204.5%201.5%206.2A8%208%200%20014.1%2013zm7.3%207A12%2012%200%20019%2013h6.2c-.3%202.8-1.2%205.2-2.6%207h-1.2zm4-.8c1-1.8%201.6-3.9%201.8-6.2h2.7a8%208%200%2001-4.4%206.2z'/%3e%3c/svg%3e", K2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M12.22%203a9.23%209.23%200%200%200-8.23%204.97%208.71%208.71%200%200%200%200%208.05A9.23%209.23%200%200%200%2012.22%2021c2.53%200%204.6-.82%206.08-2.17a8.68%208.68%200%200%200%202.7-6.6c0-.3-.01-.6-.04-.9h-7.74v1.76h5.73l-.24%201.2a5.64%205.64%200%200%201-2.48%203.62%207.26%207.26%200%200%201-4.01%201.13A7.09%207.09%200%200%201%205.16%2012a7.09%207.09%200%200%201%207.05-7.04c1.42%200%202.74.39%203.86%201.16l1.48-1.45A8.93%208.93%200%200%200%2012.22%203ZM2.2%207.06A11.23%2011.23%200%200%201%2012.2%201a10.9%2010.9%200%200%201%207.51%202.87l.78.71-.75.74-2.92%202.85-.68.67-.7-.65a4.61%204.61%200%200%200-3.23-1.23A5.09%205.09%200%200%200%207.16%2012c0%20.56.1%201.08.27%201.57v.02a5.09%205.09%200%200%200%204.79%203.45c1.2%200%202.17-.31%202.91-.8.48-.31.86-.7%201.14-1.15h-5.05V9.33h11.46l.14.84c.11.65.18%201.34.18%202.05%200%203.3-1.2%206.14-3.36%208.1A10.85%2010.85%200%200%201%2012.22%2023c-4.38%200-8.17-2.47-10.01-6.06a10.71%2010.71%200%200%201%200-9.88Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", W2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M11%207h2v2h-2V7zm0%204h2v6h-2v-6zm1-9a10%2010%200%20100%2020%2010%2010%200%20000-20zm0%2018a8%208%200%20110-16%208%208%200%20010%2016z'/%3e%3c/svg%3e", Q2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M12%205.44c2.14%200%202.39.01%203.23.05.51%200%201.01.1%201.49.27.35.13.66.34.92.6.26.26.47.58.6.92.17.48.27.98.27%201.49.04.84.05%201.1.05%203.23s0%202.4-.05%203.23c0%20.51-.1%201.01-.27%201.49a2.64%202.64%200%2001-1.52%201.52c-.48.17-.98.27-1.48.27-.85.04-1.1.05-3.24.05-2.13%200-2.39%200-3.23-.05-.5%200-1.01-.1-1.49-.27a2.47%202.47%200%2001-.92-.6%202.47%202.47%200%2001-.6-.92%204.42%204.42%200%2001-.27-1.49c-.04-.84-.05-1.1-.05-3.23s.01-2.39.05-3.23c0-.51.1-1.01.27-1.49.13-.35.34-.66.6-.92.26-.26.58-.47.92-.6.48-.17.98-.27%201.49-.27.84-.04%201.1-.05%203.23-.05zM12%204c-2.17%200-2.45%200-3.3.05-.66.01-1.32.14-1.94.37a3.9%203.9%200%2000-1.42.92c-.4.4-.72.89-.92%201.42a5.87%205.87%200%2000-.37%201.94C4%209.56%204%209.83%204%2012s0%202.45.05%203.3c.01.66.14%201.32.37%201.94.2.53.52%201.02.92%201.42.4.4.89.72%201.42.92.62.23%201.28.36%201.94.37.86.04%201.13.05%203.3.05s2.45%200%203.3-.05a5.87%205.87%200%20001.94-.37%204.1%204.1%200%20002.34-2.34c.24-.62.36-1.28.37-1.94.04-.86.05-1.13.05-3.3%200-2.18%200-2.45-.05-3.3a5.87%205.87%200%2000-.37-1.94%203.9%203.9%200%2000-.92-1.42%203.9%203.9%200%2000-1.42-.92%205.87%205.87%200%2000-1.94-.37C14.44%204%2014.17%204%2012%204zm0%203.9a4.1%204.1%200%20100%208.2%204.1%204.1%200%20000-8.2zm0%206.77a2.67%202.67%200%20110-5.34%202.67%202.67%200%20010%205.34zm5.23-6.94a.96.96%200%2011-1.92%200%20.96.96%200%20011.92%200z'%20clip-rule='evenodd'/%3e%3c/svg%3e", J2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M19.3%204H4.7c-.4%200-.7.3-.7.7v14.7c0%20.3.3.6.7.6h14.7c.4%200%20.7-.3.7-.7V4.7c-.1-.4-.4-.7-.8-.7zM8.7%2017.6H6.4V10h2.4v7.6h-.1zM7.6%209c-.8%200-1.4-.7-1.4-1.4%200-.8.6-1.4%201.4-1.4.8%200%201.4.6%201.4%201.4-.1.7-.7%201.4-1.4%201.4zm10%208.6h-2.4v-3.7c0-.9%200-2-1.2-2s-1.4%201-1.4%202v3.8h-2.4V10h2.3v1c.3-.6%201.1-1.2%202.2-1.2%202.4%200%202.8%201.6%202.8%203.6v4.2h.1z'/%3e%3c/svg%3e", ee = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M3%2013h2v-2H3v2zm0%204h2v-2H3v2zm0-8h2V7H3v2zm4%204h14v-2H7v2zm0%204h14v-2H7v2zM7%207v2h14V7H7zm-4%206h2v-2H3v2zm0%204h2v-2H3v2zm0-8h2V7H3v2zm4%204h14v-2H7v2zm0%204h14v-2H7v2zM7%207v2h14V7H7z'/%3e%3c/svg%3e", ae = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M5.298%2016.359%207.657%2014H2v5.657l1.86-1.86A9.99%209.99%200%200%200%2012%2022c4.83%200%208.87-3.44%209.8-8h-2.05c-.9%203.45-4.03%206-7.75%206a7.998%207.998%200%200%201-6.702-3.641ZM16.343%2010H22V4.343l-1.86%201.86A9.99%209.99%200%200%200%2012%202c-4.83%200-8.87%203.44-9.8%208h2.05c.9-3.45%204.03-6%207.75-6a8%208%200%200%201%206.703%203.641L16.343%2010Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", te = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M5%209a7%207%200%201114%200c0%205.3-7%2013-7%2013S5%2014.2%205%209zm7-5a5%205%200%2000-5%205c0%202.8%203%207.2%205%209.9%202.1-2.7%205-7%205-9.9a5%205%200%2000-5-5zm2.5%205a2.5%202.5%200%2011-5%200%202.5%202.5%200%20015%200z'/%3e%3c/svg%3e", ne = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2072%2040'%3e%3cpath%20fill-rule='evenodd'%20d='M16.2%2039h39.7L72%2019.5%2055.9%200H16.2L0%2019.5%2016.2%2039zM55%2037H17L2.6%2019.4%2017.1%202H55l14.5%2017.6L55%2036.9zM17%2019.1v6.9h-2.2V10.8h4.3c1.2%200%202%20.3%202.8%201%20.6.8%201%201.7%201%203a4%204%200%2001-.6%202.2c-.3.6-.8%201-1.4%201.3.3.1.6.4.9.7l.4%201.5.6%205.5h-2.2l-.5-5.3c-.1-.5-.2-.9-.5-1.1-.2-.2-.5-.4-1-.4H17zm0-6.4v4.4H19c.5%200%201-.1%201.2-.5.4-.4.5-1%20.5-1.7%200-.8-.2-1.3-.5-1.7-.2-.3-.7-.5-1.2-.5H17zm13%2013c-.5.3-1.2.5-2%20.5s-1.4-.2-2-.6c-.6-.3-1.1-.9-1.4-1.6-.4-.6-.5-1.5-.5-2.4v-2c0-1%20.1-1.8.5-2.5A3.7%203.7%200%200128%2015c.8%200%201.4.2%202%20.6.6.4%201.1.9%201.4%201.6.4.7.5%201.5.5%202.4v2.1c0%201-.1%201.8-.5%202.4-.3.7-.8%201.3-1.4%201.6zm-3.4-2.1c.4.4.8.6%201.4.6.6%200%201-.2%201.4-.6.3-.5.5-1.1.5-2v-2.2a3%203%200%2000-.5-1.9c-.4-.4-.8-.6-1.4-.6-.6%200-1%20.2-1.4.6a3%203%200%2000-.5%201.9v2.3c0%20.8.2%201.4.5%201.9zm13.5%201.7c-.6.6-1.5%201-2.5%201-1.2%200-2.2-.5-2.9-1.3a5%205%200%2001-1-3.4v-2a5%205%200%20011-3.4c.8-.9%201.7-1.3%203-1.3%201%200%201.9.3%202.5%201%20.6.5%201%201.4%201.2%202.5l-2%20.5c-.2-1.4-.8-2-1.8-2-.6%200-1%20.2-1.4.6-.3.5-.5%201.1-.5%201.9v2.3c0%20.8.2%201.4.5%201.9.4.4.8.6%201.4.6.5%200%20.9-.1%201.2-.5.3-.3.5-.8.6-1.5l2%20.5c-.2%201.1-.6%202-1.3%202.6zm4.9-6.5V26h-2V10.8h2V16c.2-.3.5-.5%201-.8a3%203%200%20011.4-.3c1%200%201.7.3%202.2%201%20.5.5.8%201.4.8%202.5V26h-2v-7.2c0-.6-.2-1.1-.5-1.5-.3-.3-.7-.5-1.2-.5s-1%20.2-1.2.5A2%202%200%200045%2019zm13.6-2.7c.6.8%201%202%201%203.3V21H54v.9c0%20.8.2%201.4.5%201.9.4.4.8.6%201.3.6s.9-.1%201.2-.5c.3-.3.5-.7.6-1.3l1.8.4c-.1%201-.5%201.8-1.1%202.4-.7.6-1.5.9-2.5.9-1.2%200-2-.4-2.8-1.3-.7-.8-1-2-1-3.4v-2c0-1%20.1-1.7.5-2.5.3-.6.8-1.2%201.3-1.6.6-.3%201.3-.5%202-.5%201.2%200%202%20.4%202.8%201.2zm-1.4%201.3c-.4-.5-.8-.7-1.4-.7-.5%200-1%20.2-1.2.7-.4.4-.5%201-.5%201.8v.3h3.5v-.4a3%203%200%2000-.4-1.7z'%20clip-rule='evenodd'/%3e%3c/svg%3e", ie = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M9.1%2022L2%2019.8v-16l6.9%202.2%207-4L22%204.3v16.2L16%2018l-6.9%204zM4%206.5v11.9l4%201.3V7.7L4%206.4zm10-1.1l-4%202.3v11.7l4-2.3V5.3zM16%204V16l4%201.6V5.7L16%204z'/%3e%3c/svg%3e", oe = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M19%202v2h-2v3a3%203%200%20013%203v11a1%201%200%2001-1%201H5a1%201%200%2001-1-1V10a3%203%200%20013-3V4H5V2h14zm-2%207H7a1%201%200%2000-1%201v10h12V10a1%201%200%2000-1-1zm-4%202v2h2v2h-2v2h-2v-2H9v-2h2v-2h2zm2-7H9v3h6V4z'/%3e%3c/svg%3e", se = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M4%2011h16v2H4v-2z'/%3e%3c/svg%3e", le = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2032%2032'%3e%3cpath%20d='M15.132%2016.192L6.47%2024.854l1.06%201.061%208.662-8.662%208.663%208.662%201.06-1.06-8.662-8.663%208.662-8.662-1.06-1.06-8.663%208.662L7.53%206.47%206.47%207.53l8.662%208.662z'/%3e%3c/svg%3e", re = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2032%2032'%3e%3cpath%20d='M29%208.75H3v-1.5h26v1.5zm0%207.5H3v-1.5h26v1.5zm0%207.5H3v-1.5h26v1.5z'/%3e%3c/svg%3e", ce = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2032%2032'%3e%3cpath%20fill-rule='evenodd'%20d='M22.167%2013.333a7.833%207.833%200%2011-15.667%200%207.833%207.833%200%200115.667%200zm-2.568%207.708a9.333%209.333%200%20111.168-.945l6.121%206.733-1.11%201.009L19.6%2021.04z'/%3e%3c/svg%3e", _e = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M15.5%201h-8A2.5%202.5%200%20005%203.5v17C5%2021.9%206.1%2023%207.5%2023h8c1.4%200%202.5-1.1%202.5-2.5v-17C18%202.1%2016.9%201%2015.5%201zm-4%2021a1.5%201.5%200%20110-3%201.5%201.5%200%20010%203zm4.5-4H7V4h9v14z'/%3e%3c/svg%3e", ge = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M4%2011a7%207%200%200%200%207-7h2a7%207%200%200%200%207%207v2a7%207%200%200%200-7%207h-2a7%207%200%200%200-7-7v-2Zm4.127%201A9.04%209.04%200%200%201%2012%2015.873%209.04%209.04%200%200%201%2015.873%2012%209.04%209.04%200%200%201%2012%208.127%209.04%209.04%200%200%201%208.127%2012Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", de = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill-rule='evenodd'%20d='M4%2017.8V6.2l8-1.7v15l-8-1.7ZM2%204.6l10-2.2%202-.4v4h8.5v12H14v4l-2-.4-10-2.2V4.6Zm12%205.8V16h6.5v-6l-3.4%202.3-.7.5-.6-.6-1.8-1.8ZM19.8%208h-5.4l2.2%202.2L19.8%208ZM7%2012c0-.7.2-1.2.4-1.6L8%2010c.1%200%20.3%200%20.6.4a3.4%203.4%200%200%201%200%203.2L8%2014c-.1%200-.3%200-.6-.4-.2-.4-.4-1-.4-1.6Zm1-4c-1%200-1.8.6-2.2%201.3a5%205%200%200%200%200%205.4C6.2%2015.4%207%2016%208%2016c1%200%201.8-.6%202.2-1.3a5%205%200%200%200%200-5.4A2.7%202.7%200%200%200%208%208Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", he = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M12.2%203a.7.7%200%2000-.5.2h-.1a6.3%206.3%200%2000-7.8%204.2c-.3%201-.4%202-.2%203l-1%201a2.1%202.1%200%2000.9%203.4c.3.1.6.2%201%20.1a2.1%202.1%200%20001.8%201.6%202.1%202.1%200%20002%202c0%20.4.3%201%20.6%201.3.8.8%202%20.8%202.8.2l.4.4a2.2%202.2%200%20003.7-1.3%202.1%202.1%200%20001.9-2%202.1%202.1%200%20001.9-1.6%202.1%202.1%200%20002.4-2%202.1%202.1%200%2000-.7-1.6l-.8-.8.2-.7a6%206%200%2000-2.8-6.6%206%206%200%2000-3-.8h-1.7-1zm3%205l3.4%203.4%201.7%201.6a.6.6%200%2001-.5%201l-.4-.1-1.6-1.7a.8.8%200%2000-1.1%200%20.7.7%200%20000%201.1l1.2%201.3a.6.6%200%2001-.4%201h-.4a.8.8%200%2000-1.2.5c0%20.2%200%20.3.2.5a.6.6%200%2001-.5%201c-.1%200-.3%200-.4-.2a.8.8%200%2000-1.2.6l.1.5a.6.6%200%2001-.5%201c-.1%200-.3%200-.4-.2l-.4-.3.1-.2a2.1%202.1%200%2000-1.4-3.6%202.1%202.1%200%2000-2-2%202.1%202.1%200%2000-1.4-1.8h-1a2.1%202.1%200%2000-2-1.7%204.7%204.7%200%20013-4.9c.6-.2%201.2-.3%201.9-.3L8.5%205.6a2.3%202.3%200%20001%204.2c.7%200%201.3%200%201.8-.5L13.2%208h2zM9.4%206.7l3.1-2.3h2.3a4.5%204.5%200%20014.5%205.3L16%206.6a.7.7%200%2000-.6-.2H13c-.1%200-.3%200-.4.2L10.4%208a.8.8%200%2001-1.3-.4.8.8%200%2001.3-.9zm-3.4%208a.6.6%200%20010-.9l1-1a.6.6%200%2001.9%200%20.6.6%200%20010%201l-1%20.9a.6.6%200%2001-.9%200zm-.5-3.4a.6.6%200%20010%20.9l-1%201a.6.6%200%2001-1-.3.6.6%200%2001.2-.6l1-1a.6.6%200%2001.8%200zm5.4%207.3a.6.6%200%2001-1-.2.6.6%200%2001.1-.6l1-1a.6.6%200%20011%20.2.6.6%200%2001-.2.7l-1%201zm-2-2a.6.6%200%2001-1.1-.4c0-.2%200-.3.2-.4l1-1a.6.6%200%20011%20.2.6.6%200%2001-.2.7l-1%201z'/%3e%3c/svg%3e", ve = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M18.8%2012h-6a1.5%201.5%200%2000-1.6%201.5V18H3v-7.5H1.5v12H3v-3h18v3h1.5v-6.8a3.8%203.8%200%2000-3.8-3.7zm2.2%206h-8.3v-4.5h6a2.3%202.3%200%20012.3%202.3V18z'/%3e%3cpath%20d='M7.1%2012.8a1.1%201.1%200%20110%202.2%201.1%201.1%200%20010-2.3zm0-1.6a2.6%202.6%200%20100%205.3%202.6%202.6%200%20000-5.3zM15.8%204.5h-3v-3h-1.6v3h-3V6h3v3h1.6V6h3V4.5z'/%3e%3c/svg%3e", me = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M6.5%205a1%201%200%20112%200%201%201%200%2001-2%200zm1-3a3%203%200%20100%206%203%203%200%20000-6zm8%203a1%201%200%20112%200%201%201%200%2001-2%200zm1-3a3%203%200%20100%206%203%203%200%20000-6zM4.3%209.3c.2-.2.4-.3.7-.3h5a1%201%200%20011%201l-1%2011c0%20.6-.5%201-1%201H6a1%201%200%2001-1-1L4%2010c0-.2%200-.5.3-.7zM6%2011l.8%209h1.2l.8-9H6.1zM14%209a1%201%200%2000-1%201l1%2011c0%20.6.5%201%201%201h3c.5%200%201-.4%201-1l1-11a1%201%200%2000-1-1h-5zm2%2011l-.9-9h2.8l-.8%209h-1.2z'%20clip-rule='evenodd'/%3e%3c/svg%3e", we = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M6.5%205L7%207.6%205.8%208.8C5.4%207.6%205%206.3%205%205h1.5zm9.9%2012c.9.3%201.7.4%202.6.5V19c-1.3-.1-2.6-.4-3.8-.8l1.2-1.2zM7.5%203H4a1%201%200%2000-1%201%2017%2017%200%200017%2017c.6%200%201-.4%201-1v-3.5c0-.5-.4-1-1-1a11.4%2011.4%200%2001-3.9-.6%201%201%200%2000-.7.3l-2.2%202.2a15.1%2015.1%200%2001-6.6-6.6l2.2-2.2c.3-.3.4-.7.3-1-.4-1.1-.6-2.3-.6-3.6%200-.5-.4-1-1-1z'/%3e%3c/svg%3e", ue = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2056%2056'%3e%3cpath%20fill-rule='evenodd'%20d='M51%2028c0%2012.703-10.297%2023-23%2023S5%2040.703%205%2028%2015.297%205%2028%205s23%2010.297%2023%2023Zm5%200c0%2015.464-12.536%2028-28%2028S0%2043.464%200%2028%2012.536%200%2028%200s28%2012.536%2028%2028Zm-18.801%201.854a1.333%201.333%200%200%200%200-2.309l-13.85-7.996c-.89-.514-2%20.128-2%201.154v15.993a1.333%201.333%200%200%200%202%201.155l13.85-7.997Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", pe = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M11.3%203.6h1.4l.2.1v16.6l-.2.1h-1.4l-.2-.1V3.6l.2-.1z'/%3e%3cpath%20d='M4.1%2011.1H20c.1%200%20.2%200%20.2.2v1.4l-.2.2H4c-.1%200-.2%200-.2-.2v-1.4l.2-.2z'/%3e%3c/svg%3e", be = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M14%2012c0%20.74-.4%201.38-1%201.72V22h-2v-8.28c-.6-.35-1-.98-1-1.72%200-1.1.9-2%202-2s2%20.9%202%202Zm-2-6c-3.31%200-6%202.69-6%206%200%201.74.75%203.31%201.94%204.4l1.42-1.42A3.956%203.956%200%200%201%208%2012c0-2.21%201.79-4%204-4s4%201.79%204%204c0%201.19-.53%202.25-1.36%202.98l1.42%201.42A5.957%205.957%200%200%200%2018%2012c0-3.31-2.69-6-6-6Zm0-4C6.48%202%202%206.48%202%2012c0%202.85%201.2%205.41%203.11%207.24l1.42-1.42A7.986%207.986%200%200%201%204%2012c0-4.41%203.59-8%208-8s8%203.59%208%208c0%202.29-.98%204.36-2.53%205.82l1.42%201.42C20.8%2017.41%2022%2014.85%2022%2012c0-5.52-4.48-10-10-10Z'/%3e%3c/svg%3e", xe = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M12%201.5a10.5%2010.5%200%20100%2021%2010.5%2010.5%200%20000-21zm4.4%2013.7l-1.2%201.2L12%2013l-3.2%203.3-1.2-1.2L11%2012%207.6%208.8l1.2-1.2L12%2011l3.2-3.3%201.2%201.2L13%2012l3.3%203.2z'/%3e%3c/svg%3e", fe = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2032%2032'%3e%3cpath%20fill-rule='evenodd'%20d='M22.167%2013.333a7.833%207.833%200%201%201-15.667%200%207.833%207.833%200%200%201%2015.667%200Zm-2.568%207.708a9.333%209.333%200%201%201%201.168-.945l6.121%206.733-1.11%201.009L19.6%2021.04Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", Ne = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M10%2018a8%208%200%20004.9-1.7l4.4%204.4%201.4-1.4-4.4-4.4A8%208%200%201010%2018zm0-14a6%206%200%20110%2012%206%206%200%20010-12z'/%3e%3c/svg%3e", Ae = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='m11.99%2018.54-7.37-5.73L3%2014.07l9%207%209-7-1.63-1.27-7.38%205.74ZM12%2016l7.36-5.73L21%209l-9-7-9%207%201.63%201.27L12%2016Zm0-11.47L17.74%209%2012%2013.47%206.26%209%2012%204.53Z'/%3e%3c/svg%3e", Me = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2032%2032'%3e%3cpath%20d='M26%2021h-4.5v2h8v-8h-2v4.6l-10.3-9.3-.7-.7-.7.7-5.3%205.3-7.8-7.3-1.4%201.4%208.5%208%20.7.7.7-.7%205.3-5.3L26%2021Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", ze = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2032%2032'%3e%3cpath%20d='m25.6%2016.9-3.3%203.3%201.4%201.4%205-5%20.7-.7-.7-.7-5-5-1.4%201.5%203.2%203.2H3v2h22.6Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", Ve = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2032%2032'%3e%3cpath%20d='M26%2010h-4.5V8h8v8h-2v-4.6l-10.3%209.3-.7.7-.7-.7-5.3-5.3-7.8%207.3-1.4-1.4%208.5-8%20.7-.7.7.7%205.3%205.3L26%2010Z'%20clip-rule='evenodd'/%3e%3c/svg%3e", He = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M12%202a10%2010%200%20100%2020%2010%2010%200%20000-20zm0%2018a8%208%200%20110-16%208%208%200%20010%2016z'/%3e%3cpath%20d='M13%207h-2v6h6v-2h-4V7z'/%3e%3c/svg%3e", ye = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M17.1761%204H19.9362L13.9061%2010.7774L21%2020H15.4456L11.0951%2014.4066L6.11723%2020H3.35544L9.80517%2012.7508L3%204H8.69545L12.6279%209.11262L17.1761%204ZM16.2073%2018.3754H17.7368L7.86441%205.53928H6.2232L16.2073%2018.3754Z'%20/%3e%3c/svg%3e", Ie = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M8%207l4-4%204%204h-3v8h-2V7H8zM3%2019c0%201.1.9%202%202%202h14a2%202%200%20002-2v-5h-2v5H5v-5H3v5z'%20clip-rule='evenodd'/%3e%3c/svg%3e", Ce = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cpath%20d='M20.85%208.7s-.15-1.27-.75-1.8c-.68-.75-1.43-.75-1.8-.75C15.75%206%2012%206%2012%206s-3.75%200-6.3.15c-.38.07-1.13.07-1.8.75-.52.52-.75%201.8-.75%201.8S3%2010.13%203%2011.63v1.34a34%2034%200%2000.15%202.93s.15%201.28.75%201.8c.68.75%201.57.68%201.95.75%201.43.15%206.15.15%206.15.15s3.75%200%206.3-.23c.38-.07%201.13-.07%201.8-.75.52-.52.75-1.8.75-1.8S21%2014.4%2021%2012.9v-1.35c0-1.43-.15-2.85-.15-2.85zm-10.73%205.93V9.6L15%2012.15l-4.88%202.47z'/%3e%3c/svg%3e", M0 = {
  additional: m2,
  "arrow-down": w2,
  "arrow-left": u2,
  "arrow-light-down": p2,
  "arrow-light-left": b2,
  "arrow-light-right": x2,
  "arrow-light-up": f2,
  "arrow-right": N2,
  "arrow-up": A2,
  book: M2,
  calendar: z2,
  checkmark: V2,
  "chevron-down": H2,
  "chevron-left": y2,
  "chevron-right": I2,
  "chevron-up": C2,
  circle: E2,
  close: R2,
  "color-indicator": B2,
  connected: T2,
  "copy-link": k2,
  cross: D2,
  "default-avatar": $2,
  diagnostics: O2,
  download: q2,
  dropdown: Z2,
  dummy: S2,
  email: G2,
  "external-link": U2,
  facebook: F2,
  fax: L2,
  "file-download": j2,
  file: P2,
  filter: X2,
  globe: Y2,
  "google-cal": K2,
  info: W2,
  instagram: Q2,
  linkedin: J2,
  list: ee,
  loading: ae,
  location: te,
  logo: ne,
  map: ie,
  medicine: oe,
  minus: se,
  "mobile-close": le,
  "mobile-menu": re,
  "mobile-search": ce,
  mobile: _e,
  "molecular-item": ge,
  outlook: de,
  partnership: he,
  patient: ve,
  people: me,
  phone: we,
  play: ue,
  plus: pe,
  podcasts: be,
  remove: xe,
  "search-mobile": fe,
  search: Ne,
  series: Ae,
  "stock-down": Me,
  "stock-equal": ze,
  "stock-up": Ve,
  time: He,
  twitter: ye,
  upload: Ie,
  youtube: Ce
}, Ee = "icon", Re = {
  icon: Ee
}, ft = ({ name: e, size: t }) => {
  if (!Object.keys(M0).includes(e))
    throw new Error(`Icon "${e}" not found.`);
  const i = M0[e];
  return /* @__PURE__ */ a(i, { className: b(Re.icon), width: t, height: t });
};
var g0 = /* @__PURE__ */ ((e) => (e.HD = "16:9", e.WIDE = "2.39:1", e.SQUARE = "1:1", e.VERTICAL = "4:5", e.ORIGINAL = "original", e.NORMAL = "4:3", e.SIXTOFIVE = "6:5", e))(g0 || {});
const Be = {
  "lead-text": "lead-text"
}, Nt = ({ lead: e }) => /* @__PURE__ */ a("p", { className: Be["lead-text"], children: e }), F = {
  "roche-quote": "roche-quote",
  "roche-quote__image": "roche-quote__image",
  "roche-quote__content": "roche-quote__content",
  "roche-quote__text": "roche-quote__text",
  "roche-quote__text--small": "roche-quote__text--small",
  "roche-quote__subline": "roche-quote__subline",
  "roche-quote__link": "roche-quote__link",
  "roche-quote--with-image": "roche-quote--with-image",
  "roche-quote--equal-ratio": "roche-quote--equal-ratio"
};
var d0 = /* @__PURE__ */ ((e) => (e.BIG = "big", e.SMALL = "small", e))(d0 || {}), h0 = /* @__PURE__ */ ((e) => (e.WITH_IMAGE = "with-image", e.NORMAL = "normal", e))(h0 || {});
const At = ({
  quote: e,
  size: t = d0.BIG,
  layout: i = h0.NORMAL,
  isEqualRatio: n = !1,
  image: o,
  sublines: s,
  link: l
}) => {
  const d = i === h0.WITH_IMAGE, g = t === d0.SMALL, _ = b(F["roche-quote"], {
    [F["roche-quote--with-image"]]: d,
    [F["roche-quote--equal-ratio"]]: n
  }), r = b(F["roche-quote__text"], {
    [F["roche-quote__text--small"]]: g
  });
  return /* @__PURE__ */ c("figure", { className: _, children: [
    d && /* @__PURE__ */ a("div", { className: F["roche-quote__image"], children: o }),
    /* @__PURE__ */ c("div", { className: F["roche-quote__content"], children: [
      /* @__PURE__ */ a("blockquote", { children: /* @__PURE__ */ a("p", { className: r, children: e }) }),
      /* @__PURE__ */ c("figcaption", { children: [
        s && s.length > 0 && /* @__PURE__ */ a("div", { className: F["roche-quote__subline"], children: s }),
        d && l && /* @__PURE__ */ a("div", { className: F["roche-quote__link"], children: l })
      ] })
    ] })
  ] });
}, Te = "gnw_table_border_collapse", ke = "gnw_heading", De = "gnw_subhead", $e = "gnw_colhead", Oe = "gnw_colhead_uline", qe = "gnw_colhead_dline", Ze = "gnw_label", Se = "gnw_label_uline", Ge = "gnw_label_uline_i10", Ue = "gnw_label_uline_i15", Fe = "gnw_label_uline_i20", Le = "gnw_label_uline_i25", je = "gnw_label_uline_i30", Pe = "gnw_label_dline_i10", Xe = "gnw_label_dline_i15", Ye = "gnw_label_dline_i20", Ke = "gnw_label_dline_i25", We = "gnw_label_dline_i30", Qe = "gnw_label_ulinetop", Je = "gnw_label_dline", ea = "gnw_label_i10", aa = "gnw_label_i15", ta = "gnw_label_i20", na = "gnw_label_i25", ia = "gnw_label_i30", oa = "gnw_num", sa = "gnw_num_uline", la = "gnw_num_ulinetop", ra = "gnw_num_dline", ca = "gnw_num_dlinetop", _a = "gnw_data", ga = "gnw_data_uline", da = "gnw_data_dline", ha = "gnw_news_media_box", va = "gnw_media_caption", ma = "gnw_media_bgcolor", wa = "gnw_table", ua = "gnw_videotitle", pa = "gnw_border_top_solid", ba = "gnw_border_right_solid", xa = "gnw_border_bottom_solid", fa = "gnw_border_left_solid", Na = "gnw_border_top_double", Aa = "gnw_border_right_double", Ma = "gnw_border_bottom_double", za = "gnw_border_left_double", Va = "gnw_align_left", Ha = "gnw_align_center", ya = "gnw_align_right", Ia = "gnw_align_justify", Ca = "gnw_vertical_align_top", Ea = "gnw_vertical_align_middle", Ra = "gnw_vertical_align_bottom", Ba = "gnw_padding_left_none", Ta = "gnw_padding_right_none", ka = "gnw_table_border_spacing", Da = "gnw_release_detail_printview", $a = "gnw_hidden_cell", Oa = "hugin", qa = "superscript", Za = "subscript", c0 = {
  "rich-text": "rich-text",
  gnw_table_border_collapse: Te,
  gnw_heading: ke,
  gnw_subhead: De,
  gnw_colhead: $e,
  gnw_colhead_uline: Oe,
  gnw_colhead_dline: qe,
  gnw_label: Ze,
  gnw_label_uline: Se,
  gnw_label_uline_i10: Ge,
  gnw_label_uline_i15: Ue,
  gnw_label_uline_i20: Fe,
  gnw_label_uline_i25: Le,
  gnw_label_uline_i30: je,
  gnw_label_dline_i10: Pe,
  gnw_label_dline_i15: Xe,
  gnw_label_dline_i20: Ye,
  gnw_label_dline_i25: Ke,
  gnw_label_dline_i30: We,
  gnw_label_ulinetop: Qe,
  gnw_label_dline: Je,
  gnw_label_i10: ea,
  gnw_label_i15: aa,
  gnw_label_i20: ta,
  gnw_label_i25: na,
  gnw_label_i30: ia,
  gnw_num: oa,
  gnw_num_uline: sa,
  gnw_num_ulinetop: la,
  gnw_num_dline: ra,
  gnw_num_dlinetop: ca,
  gnw_data: _a,
  gnw_data_uline: ga,
  gnw_data_dline: da,
  gnw_news_media_box: ha,
  gnw_media_caption: va,
  gnw_media_bgcolor: ma,
  gnw_table: wa,
  gnw_videotitle: ua,
  gnw_border_top_solid: pa,
  gnw_border_right_solid: ba,
  gnw_border_bottom_solid: xa,
  gnw_border_left_solid: fa,
  gnw_border_top_double: Na,
  gnw_border_right_double: Aa,
  gnw_border_bottom_double: Ma,
  gnw_border_left_double: za,
  gnw_align_left: Va,
  gnw_align_center: Ha,
  gnw_align_right: ya,
  gnw_align_justify: Ia,
  gnw_vertical_align_top: Ca,
  gnw_vertical_align_middle: Ea,
  gnw_vertical_align_bottom: Ra,
  gnw_padding_left_none: Ba,
  gnw_padding_right_none: Ta,
  gnw_table_border_spacing: ka,
  gnw_release_detail_printview: Da,
  "logo-area_printview": "logo-area_printview",
  gnw_hidden_cell: $a,
  "rich-text--is-footnote": "rich-text--is-footnote",
  "rich-text--is-footer-type": "rich-text--is-footer-type",
  hugin: Oa,
  superscript: qa,
  subscript: Za
}, Mt = ({
  children: e,
  isFootnote: t,
  isFooterType: i,
  markup: n,
  slot: o,
  dir: s
}) => {
  const l = {
    ...n && { dangerouslySetInnerHTML: { __html: n } }
  };
  return /* @__PURE__ */ a(
    "div",
    {
      slot: o,
      dir: s,
      ...l,
      className: b(
        c0["rich-text"],
        t && c0["rich-text--is-footnote"],
        i && c0["rich-text--is-footer-type"]
      ),
      children: e
    }
  );
};
var v0 = /* @__PURE__ */ ((e) => (e.VARIANT_A = "hero--variant-a", e.VARIANT_B = "hero--variant-b", e))(v0 || {});
const Z = {
  "staging-hero": "staging-hero",
  "staging-hero__background": "staging-hero__background",
  "staging-hero__image": "staging-hero__image",
  "staging-hero__wrapper": "staging-hero__wrapper",
  "staging-hero__content": "staging-hero__content",
  "staging-hero__headline": "staging-hero__headline",
  "staging-hero__text": "staging-hero__text",
  "staging-hero__divider": "staging-hero__divider",
  "hero--variant-a": "hero--variant-a",
  "staging-hero__letter": "staging-hero__letter",
  "hero--variant-b": "hero--variant-b"
}, zt = ({
  variant: e = v0.VARIANT_A,
  headline: t,
  content: i,
  Image: n,
  slot: o
}) => {
  const s = e === v0.VARIANT_B, l = O(null), d = [Z["staging-hero"], Z[e]].filter(Boolean).join(" ");
  C(() => {
    var r;
    const _ = (r = l.current) == null ? void 0 : r.closest("roche-grid");
    return _ && (_.setAttribute("no-padding", "true"), _.setAttribute("data-staging-hero", e)), () => {
      _ && (_.removeAttribute("no-padding"), _.removeAttribute("data-staging-hero"));
    };
  }, [e]);
  const g = s && n;
  return /* @__PURE__ */ c("section", { ref: l, className: d, "data-variant": e, slot: o, children: [
    /* @__PURE__ */ c("div", { className: Z["staging-hero__wrapper"], children: [
      /* @__PURE__ */ a("div", { className: Z["staging-hero__background"] }),
      /* @__PURE__ */ c("div", { className: Z["staging-hero__content"], children: [
        /* @__PURE__ */ a("div", { className: Z["staging-hero__letter"] }),
        t && /* @__PURE__ */ a("h1", { className: Z["staging-hero__headline"], children: t }),
        i && /* @__PURE__ */ a("p", { className: Z["staging-hero__text"], children: i })
      ] }),
      /* @__PURE__ */ a("div", { className: Z["staging-hero__divider"] })
    ] }),
    g && /* @__PURE__ */ a("div", { className: Z["staging-hero__image"], children: n })
  ] });
}, T0 = 2, k0 = (e, t = "", i = T0) => {
  const n = ["-", "", "+"][Math.sign(e) + 1], o = Math.abs(e).toFixed(i);
  return `${n}${t}${o}`;
}, Sa = (e) => `${k0(e, " ")}`, Ga = (e) => `(${k0(e)}%)`, y = {
  "stock-price": "stock-price",
  "stock-price__heading": "stock-price__heading",
  "stock-price__price": "stock-price__price",
  "stock-price__value": "stock-price__value",
  "stock-price__currency": "stock-price__currency",
  "stock-price__unavailable": "stock-price__unavailable",
  "stock-price__daily-change": "stock-price__daily-change",
  "stock-price__difference": "stock-price__difference",
  "stock-price__relative-difference": "stock-price__relative-difference",
  "stock-price__price-difference": "stock-price__price-difference",
  "stock-price__icon": "stock-price__icon",
  "stock-price__icon--down": "stock-price__icon--down",
  "stock-price__icon--equal": "stock-price__icon--equal",
  "stock-price__icon--up": "stock-price__icon--up"
}, Vt = ({
  heading: e,
  href: t,
  price: i,
  currency: n,
  change: o,
  relativeChange: s,
  timeIntervalLabel: l,
  unavailableLabel: d
}) => {
  if (!(i !== void 0 && n !== void 0 && o !== void 0 && s !== void 0))
    return /* @__PURE__ */ c("div", { className: y["stock-price"], children: [
      /* @__PURE__ */ a("h3", { className: y["stock-price__heading"], children: e }),
      /* @__PURE__ */ a("span", { className: y["stock-price__unavailable"], children: d })
    ] });
  const _ = ["stock-down", "stock-equal", "stock-up"][Math.sign(o) + 1], r = b(y["stock-price__icon"], {
    [y["stock-price__icon--down"]]: _ === "stock-down",
    [y["stock-price__icon--equal"]]: _ === "stock-equal",
    [y["stock-price__icon--up"]]: _ === "stock-up"
  });
  return /* @__PURE__ */ c("a", { className: y["stock-price"], href: t, children: [
    /* @__PURE__ */ a("h3", { className: y["stock-price__heading"], children: e }),
    /* @__PURE__ */ c("div", { className: y["stock-price__price"], children: [
      /* @__PURE__ */ a("span", { className: y["stock-price__value"], children: i.toFixed(T0) }),
      /* @__PURE__ */ a("span", { className: y["stock-price__currency"], children: n })
    ] }),
    /* @__PURE__ */ c("div", { className: y["stock-price__daily-change"], children: [
      /* @__PURE__ */ a("span", { className: r, "aria-hidden": "true", children: /* @__PURE__ */ a("roche-icon", { icon: _, height: "2rem" }) }),
      /* @__PURE__ */ c("span", { className: y["stock-price__difference"], children: [
        /* @__PURE__ */ a("span", { className: y["stock-price__price-difference"], children: Sa(o) }),
        /* @__PURE__ */ a("span", { className: y["stock-price__relative-difference"], children: Ga(s) })
      ] }),
      /* @__PURE__ */ a("span", { className: y["stock-price__time-interval"], children: l })
    ] })
  ] });
}, $ = {
  "story-teaser": "story-teaser",
  "story-teaser__tag": "story-teaser__tag",
  "story-teaser__image-container": "story-teaser__image-container",
  "story-teaser__details": "story-teaser__details",
  "story-teaser__title": "story-teaser__title",
  "story-teaser__description": "story-teaser__description",
  "story-teaser__date": "story-teaser__date",
  "story-teaser--variant-a": "story-teaser--variant-a",
  "story-teaser__description-container": "story-teaser__description-container",
  "story-teaser--variant-b": "story-teaser--variant-b",
  "story-teaser--variant-c": "story-teaser--variant-c",
  "story-teaser__button": "story-teaser__button",
  "story-teaser--unpublished": "story-teaser--unpublished"
};
var Ua = /* @__PURE__ */ ((e) => (e.VARIANT_A = "story-teaser--variant-a", e.VARIANT_B = "story-teaser--variant-b", e.VARIANT_C = "story-teaser--variant-c", e))(Ua || {}), m0 = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.PODCAST = "podcast", e.SERIES = "series", e.SLIDESHOW = "slideshow", e.VIDEO = "video", e))(m0 || {});
const Fa = {
  default: null,
  podcast: "podcasts",
  series: "series",
  slideshow: "book",
  video: "play"
}, La = (e) => {
  const [t, i] = T(0);
  return C(() => {
    const n = () => {
      e.current && i(e.current.clientWidth);
    }, o = new ResizeObserver(n);
    return e.current && o.observe(e.current), () => o.disconnect();
  }, [e.current]), { width: t };
}, ja = "date", Pa = {
  date: ja
}, D0 = ({ displayDate: e, dateTimeValue: t }) => /* @__PURE__ */ a("div", { className: Pa.date, children: /* @__PURE__ */ a("time", { dateTime: t, children: e }) }), z0 = (e) => (t) => {
  e.forEach((i) => {
    i && (typeof i == "function" ? i(t) : i.current = t);
  });
}, Ht = V0(
  ({
    layout: e,
    teaserType: t = m0.DEFAULT,
    teaserTitle: i,
    teaserDescription: n,
    teaserImage: o,
    teaserUrl: s,
    teaserDate: l,
    dateTimeValue: d,
    teaserTagLabel: g,
    ctaLabel: _,
    scaleOnScroll: r,
    unpublished: h,
    slot: m,
    onTeaserLinkClick: N
  }, u) => {
    const p = O(null), v = O(), { width: w } = La(v), [f, E] = T(0), L = w0(() => {
      const j = !Number(o);
      switch (e) {
        case "story-teaser--variant-a": {
          const q = { ratio: "4:3" };
          return j ? { src: o, ...q } : { "brightcove-id": o, ...q };
        }
        case "story-teaser--variant-b":
          return { src: j ? o : "", ...{ ratio: "6:5" } };
        case "story-teaser--variant-c": {
          const q = { "force-height": 480 };
          return j ? { src: o, ...q } : { "brightcove-id": o, ...q };
        }
        default:
          return { src: o };
      }
    }, [e, o]);
    C(() => {
      e === "story-teaser--variant-a" ? E(w ? w / 4 * 3 : 0) : p.current && E(p.current.clientHeight);
    }, [w, e, n]), C(() => {
      const j = (q) => {
        var e0;
        q.key === "Escape" && ((e0 = v.current) == null || e0.blur());
      };
      return window.addEventListener("keydown", j), () => {
        window.removeEventListener("keydown", j);
      };
    }, []);
    const M = /* @__PURE__ */ a("div", { className: $["story-teaser__image-container"], children: /* @__PURE__ */ a(
      "roche-image",
      {
        alt: "",
        style: { margin: 0 },
        ...L(),
        class: $["story-teaser__image"]
      }
    ) }), V = /* @__PURE__ */ c("div", { className: $["story-teaser__details"], children: [
      t !== m0.DEFAULT && /* @__PURE__ */ c("div", { className: $["story-teaser__tag"], children: [
        /* @__PURE__ */ a("roche-icon", { icon: Fa[t], height: `${R0(20)}rem` }),
        /* @__PURE__ */ a("span", { children: g })
      ] }),
      /* @__PURE__ */ c("div", { className: $["story-teaser__description-container"], children: [
        /* @__PURE__ */ a("h3", { className: $["story-teaser__title"], children: i }),
        /* @__PURE__ */ a("p", { ref: p, className: $["story-teaser__description"], children: n })
      ] }),
      l && d && e === "story-teaser--variant-a" && /* @__PURE__ */ a("div", { className: $["story-teaser__date"], children: /* @__PURE__ */ a(D0, { displayDate: l, dateTimeValue: d }) }),
      e === "story-teaser--variant-c" && /* @__PURE__ */ a(
        "roche-button",
        {
          text: _,
          href: s,
          onClick: N,
          class: $["story-teaser__button"]
        }
      )
    ] }), S = b($["story-teaser"], $[e], {
      [$["story-teaser--unpublished"]]: h
    }), Y = /* @__PURE__ */ a(
      "a",
      {
        ref: z0([v, u]),
        className: S,
        "aria-label": i,
        href: s,
        onClick: N,
        style: { "--teaser-hover-offset": `${f}px` },
        slot: m,
        children: /* @__PURE__ */ c("article", { children: [
          M,
          V
        ] })
      }
    ), J = /* @__PURE__ */ c("article", { ref: z0([v, u]), className: S, slot: m, children: [
      r ? /* @__PURE__ */ a("roche-scale-on-scroll", { children: M }) : M,
      V
    ] });
    return e === "story-teaser--variant-c" ? J : Y;
  }
), Xa = "subline", Ya = "subline__avatar", Ka = "subline__author", Wa = "subline__date", P = {
  subline: Xa,
  "subline__attribution-phrase": "subline__attribution-phrase",
  "subline__author-container": "subline__author-container",
  subline__avatar: Ya,
  "subline__author-description-container": "subline__author-description-container",
  subline__author: Ka,
  "subline__author-description": "subline__author-description",
  subline__date: Wa
}, yt = ({
  author: e,
  authorDescription: t,
  attributionPhrase: i,
  displayDate: n,
  dateTimeValue: o,
  children: s
}) => /* @__PURE__ */ c("div", { className: P.subline, children: [
  i && /* @__PURE__ */ a("h3", { className: P["subline__attribution-phrase"], children: i }),
  /* @__PURE__ */ c("div", { className: P["subline__author-container"], children: [
    s && /* @__PURE__ */ a("div", { className: P.subline__avatar, children: s }),
    /* @__PURE__ */ c("div", { className: P["subline__author-description-container"], children: [
      /* @__PURE__ */ a("p", { className: P.subline__author, children: e }),
      /* @__PURE__ */ a("p", { className: P["subline__author-description"], children: t }),
      n && o && /* @__PURE__ */ a("div", { className: P.subline__date, children: /* @__PURE__ */ a(D0, { dateTimeValue: o, displayDate: n }) })
    ] })
  ] })
] }), Qa = "teaser", Ja = "teaser__image", et = "teaser__heading", at = "teaser__overline", tt = "teaser__title", nt = "teaser__icon", it = "teaser__description", ot = "teaser__border", z = {
  teaser: Qa,
  "teaser__image-wrapper": "teaser__image-wrapper",
  "teaser__link-wrapper": "teaser__link-wrapper",
  teaser__image: Ja,
  "teaser__image-border": "teaser__image-border",
  teaser__heading: et,
  teaser__overline: at,
  "teaser__overline-element": "teaser__overline-element",
  teaser__title: tt,
  "teaser__title--small": "teaser__title--small",
  teaser__icon: nt,
  teaser__description: it,
  "teaser__author-description": "teaser__author-description",
  teaser__border: ot,
  "teaser__secondary-button": "teaser__secondary-button",
  "teaser__buttons-wrapper": "teaser__buttons-wrapper",
  "teaser__buttons-wrapper--align-left": "teaser__buttons-wrapper--align-left",
  "teaser--card": "teaser--card",
  "teaser--unpublished": "teaser--unpublished",
  "teaser--in-draft": "teaser--in-draft",
  "teaser__image--loaded": "teaser__image--loaded",
  "teaser__image--reduced-scale": "teaser__image--reduced-scale"
};
var x = /* @__PURE__ */ ((e) => (e.VARIANT_A = "teaser-variant-a", e.VARIANT_B = "teaser-variant-b", e.VARIANT_C = "teaser-variant-c", e.VARIANT_D = "teaser-variant-d", e.VARIANT_E = "teaser-variant-e", e.VARIANT_E_WITHOUT_DESCRIPTION = "teaser-variant-e-without-description", e.VARIANT_A_WITHOUT_IMAGE = "teaser-variant-a-without-image", e.VARIANT_B_WITHOUT_IMAGE = "teaser-variant-b-without-image", e.VARIANT_C_WITHOUT_IMAGE = "teaser-variant-c-without-image", e.VARIANT_D_WITHOUT_IMAGE = "teaser-variant-d-without-image", e.VARIANT_C_WITHOUT_IMAGE_WITH_DATE = "teaser-variant-c-without-image-with-date", e.CARD_A = "teaser--card-a", e.CARD_B = "teaser--card-b", e.CARD_C = "teaser--card-c", e.PUBMED = "teaser--pubmed", e))(x || {}), i0 = /* @__PURE__ */ ((e) => (e.DEFAULT = "arrow-right", e.DOWNLOAD = "download", e.EXTERNAL = "external-link", e))(i0 || {});
const st = [
  x.VARIANT_A,
  x.VARIANT_A_WITHOUT_IMAGE,
  x.CARD_A,
  x.VARIANT_B,
  x.VARIANT_B_WITHOUT_IMAGE,
  x.CARD_B,
  x.VARIANT_E,
  x.PUBMED
], lt = [
  x.VARIANT_A,
  x.VARIANT_A_WITHOUT_IMAGE,
  x.CARD_A,
  x.VARIANT_C,
  x.VARIANT_C_WITHOUT_IMAGE,
  x.VARIANT_C_WITHOUT_IMAGE_WITH_DATE,
  x.CARD_C,
  x.PUBMED
], rt = [
  x.VARIANT_A,
  x.VARIANT_B,
  x.VARIANT_C,
  x.VARIANT_D,
  x.VARIANT_E,
  x.VARIANT_E_WITHOUT_DESCRIPTION
], ct = [x.CARD_A, x.CARD_B, x.CARD_C], It = V0(
  ({
    teaserImage: e,
    teaserTitle: t,
    teaserDescription: i,
    teaserOverline: n,
    teaserOverlineElement: o,
    teaserUrl: s,
    target: l = o0.SELF,
    isExternalLink: d,
    isDownloadLink: g,
    layout: _,
    secondaryButton: r,
    primaryButtonText: h,
    onTeaserClick: m,
    isSearchResult: N,
    unpublished: u,
    isTeaserInDraft: p,
    teaserAuthorDescription: v,
    slot: w,
    loaded: f,
    forceAlignLeft: E
  }, L) => {
    const M = n && n !== "" || o, V = !Number(e), S = d ? i0.EXTERNAL : g ? i0.DOWNLOAD : i0.DEFAULT, Y = w0(() => {
      const a0 = _ === x.VARIANT_E || _ === x.VARIANT_E_WITHOUT_DESCRIPTION, q0 = a0 ? g0.VERTICAL : g0.HD, Z0 = lt.includes(_), S0 = st.includes(_), G0 = rt.includes(_), U0 = ct.includes(_);
      return {
        isVerticalLayout: a0,
        imageRatio: q0,
        hasOverline: Z0,
        hasDescription: S0,
        hasImage: G0,
        isCard: U0
      };
    }, [_]), { hasImage: J, isVerticalLayout: j, imageRatio: q, hasDescription: e0, hasOverline: $0, isCard: Q } = Y(), O0 = t && /* @__PURE__ */ c(
      "span",
      {
        className: b(z.teaser__title, (N || g) && z["teaser__title--small"]),
        children: [
          t,
          !Q && /* @__PURE__ */ a("roche-icon", { class: z.teaser__icon, icon: S, height: `${R0(24)}rem` })
        ]
      }
    );
    C(() => {
      const a0 = new CustomEvent("rocheTeaserInit");
      window.dispatchEvent(a0);
    }, []);
    const u0 = /* @__PURE__ */ c(_0, { children: [
      J && e && /* @__PURE__ */ c("div", { className: z["teaser__image-wrapper"], children: [
        /* @__PURE__ */ a(
          "roche-image",
          {
            alt: "",
            class: b(
              z.teaser__image,
              j && z["teaser__image--reduced-scale"],
              f && z["teaser__image--loaded"]
            ),
            ratio: q,
            ...V ? { src: e } : { "brightcove-id": e }
          }
        ),
        /* @__PURE__ */ a("div", { className: z["teaser__image-border"] })
      ] }),
      /* @__PURE__ */ c("h3", { className: z.teaser__heading, children: [
        O0,
        $0 && M && /* @__PURE__ */ c("span", { className: z.teaser__overline, children: [
          n,
          o && /* @__PURE__ */ a("span", { className: z["teaser__overline-element"], children: o })
        ] })
      ] }),
      v && /* @__PURE__ */ a("p", { className: "teaser__author-description", children: v }),
      e0 && i && /* @__PURE__ */ a("p", { className: z.teaser__description, children: i }),
      !J && !Q && /* @__PURE__ */ a("div", { className: z.teaser__border }),
      Q && /* @__PURE__ */ c(
        "div",
        {
          className: b(
            z["teaser__buttons-wrapper"],
            E && z["teaser__buttons-wrapper--align-left"]
          ),
          children: [
            s && /* @__PURE__ */ a(
              "roche-button",
              {
                href: s,
                appearance: "secondary",
                text: h,
                onClick: m
              }
            ),
            r && /* @__PURE__ */ a("div", { className: z["teaser__secondary-button"], children: r })
          ]
        }
      )
    ] });
    return /* @__PURE__ */ a(
      "div",
      {
        ref: L,
        slot: w,
        className: b(
          z.teaser,
          Q && z["teaser--card"],
          u && z["teaser--unpublished"],
          p && z["teaser--in-draft"]
        ),
        children: Q ? u0 : /* @__PURE__ */ a(
          "a",
          {
            target: l,
            href: s,
            "aria-label": t,
            onClick: m,
            className: z["teaser__link-wrapper"],
            children: u0
          }
        )
      }
    );
  }
);
export {
  o0 as LinkTarget,
  dt as RocheUIAddToCalendar,
  ht as RocheUIAnimatedWords,
  vt as RocheUIAvatar,
  mt as RocheUIBackToBranch,
  wt as RocheUIContactPerson,
  n0 as RocheUIContactPersonLayout,
  ut as RocheUIFooter,
  pt as RocheUIHeader,
  bt as RocheUIHeroTeaser,
  xt as RocheUIHighlightBox,
  ft as RocheUIIcon,
  g0 as RocheUIImageRatio,
  E0 as RocheUILanguageSwitch,
  s0 as RocheUILanguageSwitchLayoutType,
  Nt as RocheUILeadText,
  s2 as RocheUIMobileNavigation,
  Q0 as RocheUIOverline,
  At as RocheUIQuote,
  h0 as RocheUIQuoteLayout,
  d0 as RocheUIQuoteSize,
  Mt as RocheUIRichText,
  zt as RocheUIStagingHero,
  v0 as RocheUIStagingHeroVariant,
  Vt as RocheUIStockPrice,
  Ht as RocheUIStoryTeaser,
  Ua as RocheUIStoryTeaserLayout,
  m0 as RocheUIStoryType,
  yt as RocheUISubline,
  It as RocheUITeaser,
  x as RocheUITeaserLayout
};
